import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Pipe, ViewChild, EventEmitter, Injector, Output, Input, NgModule } from '@angular/core';
import moment from 'moment';
import { __awaiter } from 'tslib';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import * as i4 from '@taiga-ui/core';
import { TuiNotificationsService, TuiDialogService, TUI_NUMBER_FORMAT, TuiDialogModule, TuiPrimitiveTextfieldModule, TuiSvgModule, TuiRootModule, TuiTextfieldControllerModule, TuiDataListModule, TuiCalendarModule, TuiTooltipModule, TuiHintModule, TuiLoaderModule } from '@taiga-ui/core';
import * as i3 from '@angular/router';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent } from '@tinkoff/ng-polymorpheus';
import { TuiDay, TuiMonth, TuiYear, TuiLetModule } from '@taiga-ui/cdk';
import * as i4$1 from '@angular/common';
import * as i5 from '@taiga-ui/kit';
import { TuiInputModule, TuiMarkerIconModule, TuiInputNumberModule, TuiInputPhoneModule, TuiCalendarMonthModule, TuiDataListWrapperModule, TuiMultiSelectModule } from '@taiga-ui/kit';
import * as i1$1 from '@angular/platform-browser';
import { BrowserModule } from '@angular/platform-browser';
import * as i7 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i6 from 'ngx-tippy-wrapper';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import * as i9 from 'angular-ng-autocomplete';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import * as i10 from 'ng-multiselect-dropdown';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const CONFIG = {
    url: 'https://tech.virtueanalytics.com/v-api/',
    techUrl: 'https://tech.virtueanalytics.com/v-api/',
    prodUrl: 'https://api.virtueanalytics.com/api/',
    virtueTechProviderId: 'fb062996-cc17-410c-893d-3939eb6e8597',
    providerId: 'e7928d08-f92c-4974-aa09-bd3edc92a5d3',
    virtueProdProviderId: 'e7928d08-f92c-4974-aa09-bd3edc92a5d3',
    preText: '',
    baseUrl: '',
    loginUrl: '/login',
    saiUrl: 'https://tech.virtueanalytics.com/saiApp/virtue',
    prodSAIUrl: 'https://app.virtueanalytics.com/sai/virtue',
    efcUrl: 'https://tech.virtueanalytics.com/efcApp/EFC',
    prodEfcUrl: 'https://app.virtueanalytics.com/efc/EFC',
    virtueSecretToken: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJodGVzaCIsImlzcyI6ImNvbS52aXJ0dWUiLCJpYXQiOjE2NjAyMDg2MzYsImV4cCI6NjIxNDAyMDg2MzZ9.27ZXuMw0LqIhE__dFYCt8UHyl5uWLytcLU3alN5fMvczM5IuG6-HIqDeogbQiXdq3qbWMeu0GU--hJPyha4ipg"
    // providerId: '8597286c-11e5-4898-8a2c-24dc90f2b9e6'
};

// import moment from "moment"
class CodehelpService {
    constructor() { }
    generateRandomNumber(length) {
        switch (length) {
            case 2: {
                //statements; 
                return Math.floor(10 + Math.random() * (99 + 1 - 10));
                break;
            }
            case 3: {
                return Math.floor(100 + Math.random() * (999 + 1 - 100));
                break;
            }
            case 4: {
                return Math.floor(1000 + Math.random() * (9999 + 1 - 1000));
                break;
            }
            case 5: {
                return Math.floor(10000 + Math.random() * (99999 + 1 - 10000));
                break;
            }
            case 6: {
                return Math.floor(100000 + Math.random() * (999999 + 1 - 100000));
                break;
            }
            default: {
                return Math.floor(100000 + Math.random() * (999999 + 1 - 100000));
                break;
            }
        }
    }
    getStoreValue(name) {
        return localStorage.getItem(name);
    }
    setStoreValue(name, data) {
        localStorage.setItem(name, data);
    }
    removeStoreValue(name) {
        localStorage.removeItem(name);
    }
    getSessionStoreValue(name) {
        return sessionStorage.getItem(name);
    }
    setSessionStoreValue(name, data) {
        sessionStorage.setItem(name, data);
    }
    setLoggedUserDetail(user) {
        this.setStoreValue(CONFIG.preText + "loggedUser", user); //for full detail of laogin user
    }
    getLoggedUserDetail() {
        if (!CONFIG.preText) {
            const splitArr = window.location.href.split('/');
            let pretext = `${splitArr[3]}_`;
            if (splitArr[4] && splitArr[2] != 'localhost:4200') {
                pretext = pretext + `${splitArr[4]}_`;
            }
            CONFIG.preText = pretext;
        }
        return this.getStoreValue(CONFIG.preText + "loggedUser");
    }
    setLoginAuthInfo(user) {
        this.setStoreValue(CONFIG.preText + "loginAuth", user); //for las login and token
    }
    setUserProfile(user) {
        this.setStoreValue(CONFIG.preText + "userProfile", user); //for full detail of laogin user
    }
    getUserProfile() {
        if (!CONFIG.preText) {
            const splitArr = window.location.href.split('/');
            let pretext = `${splitArr[3]}_`;
            if (splitArr[4] && splitArr[2] != 'localhost:4200') {
                pretext = pretext + `${splitArr[4]}_`;
            }
            CONFIG.preText = pretext;
        }
        return this.getStoreValue(CONFIG.preText + "userProfile");
    }
    resetUserInfoLogout() {
        // .removeItem("mytime"); 
        if (!CONFIG.preText) {
            const splitArr = window.location.href.split('/');
            let pretext = `${splitArr[3]}_`;
            if (splitArr[4] && splitArr[2] != 'localhost:4200') {
                pretext = pretext + `${splitArr[4]}_`;
            }
            CONFIG.preText = pretext;
        }
        this.removeStoreValue(CONFIG.preText + "userProfile");
        this.removeStoreValue(CONFIG.preText + "loginAuth");
        this.removeStoreValue(CONFIG.preText + "loggedUser");
        this.removeStoreValue(CONFIG.preText + "authToken");
    }
    setBaseUrl(baseUrl) {
        CONFIG.baseUrl = baseUrl; //for full detail of login user
    }
    getBaseUrl() {
        return CONFIG.baseUrl;
    }
    setLoginUrl(url) {
        CONFIG.loginUrl = url; //for full detail of login user
    }
    getLoginUrl() {
        return CONFIG.loginUrl;
    }
    PV(rate, periods, payment, future, type) {
        var type = (typeof type === 'undefined') ? 0 : type;
        // Evaluate rate and periods (TODO: replace with secure expression evaluator)
        rate = eval(rate.toString());
        periods = eval(periods.toString());
        // Return present value
        if (rate === 0) {
            return Math.abs(-payment * periods - future);
        }
        else {
            return Math.abs(((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 + rate * type) - future) / Math.pow(1 + rate, periods);
        }
    }
    getLoginAuthInfo() {
        if (!CONFIG.preText) {
            const splitArr = window.location.href.split('/');
            let pretext = `${splitArr[3]}_`;
            if (splitArr[4] && splitArr[2] != 'localhost:4200') {
                pretext = pretext + `${splitArr[4]}_`;
            }
            CONFIG.preText = pretext;
        }
        return this.getStoreValue(CONFIG.preText + "loginAuth");
    }
    setAuthToken(token) {
        this.setStoreValue(CONFIG.preText + "authToken", token);
    }
    setDefaultAuthToken() {
        this.setStoreValue(CONFIG.preText + "authToken", CONFIG.virtueSecretToken);
    }
    getAuthToken() {
        const pretext = CONFIG.preText;
        if (pretext)
            return this.getStoreValue(pretext + "authToken");
        else
            return this.getStoreValue("authToken");
    }
    // setPreTextValue(value: string) {
    //   // this.codehelp.setSessionStoreValue("preText", this.basepath + '_efc_');
    //   // this.setSessionStoreValue("preText", value);
    //   CONFIG.preText = value;  `
    // }
    setProviderID(value) {
        // this.codehelp.setSessionStoreValue("preText", this.basepath + '_efc_');
        // CONFIG.preText =  //const pretext = this.getSessionStoreValue("preText");
        const splitArr = window.location.href.split('/');
        let pretext = `${splitArr[3]}_`;
        if (splitArr[4] && splitArr[2] != 'localhost:4200') {
            pretext = pretext + `${splitArr[4]}_`;
        }
        CONFIG.preText = pretext;
        this.setStoreValue(pretext + "providerID", value);
        // this.setSessionStoreValue(pretext + "providerID", value);
    }
    getProviderID() {
        // this.codehelp.setSessionStoreValue("preText", this.basepath + '_efc_');
        //this.getSessionStoreValue("preText");
        if (!CONFIG.preText) {
            const splitArr = window.location.href.split('/');
            let pretext = `${splitArr[3]}_`;
            if (splitArr[4] && splitArr[2] != 'localhost:4200') {
                pretext = pretext + `${splitArr[4]}_`;
            }
            CONFIG.preText = pretext;
        }
        const pretext = CONFIG.preText;
        // if (pretext)
        //   return this.getSessionStoreValue(pretext + "providerID");
        // else
        //   return this.getSessionStoreValue("providerID");
        if (pretext)
            return this.getStoreValue(pretext + "providerID");
        else
            return this.getStoreValue("providerID");
    }
    checkConfigCondition(configConditions, answerMap, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        let ConfigConditionMap = new Map();
        for (let i = 0; i < configConditions.length; i++) {
            let item = configConditions[i];
            let visiblityMap = new Map();
            let orvisiblityMap = new Map();
            if (item && (item === null || item === void 0 ? void 0 : item.conditions)) {
                for (let index = 0; index < (item === null || item === void 0 ? void 0 : item.conditions.length); index++) {
                    const element = item === null || item === void 0 ? void 0 : item.conditions[index];
                    const fieldid = element.fieldId;
                    let comparedfielddata = '';
                    if (answerMap.get(fieldid)) {
                        const ansobject = answerMap.get(fieldid);
                        comparedfielddata = (ansobject === null || ansobject === void 0 ? void 0 : ansobject.value) || '';
                    }
                    visiblityMap.set(index, true);
                    if (element.compareWith) {
                        if (comparedfielddata == ((_a = element.compareWith) === null || _a === void 0 ? void 0 : _a.extactValue)) {
                            visiblityMap.set(index, false);
                        }
                        else if ((_b = element.compareWith) === null || _b === void 0 ? void 0 : _b.contains) {
                            if (comparedfielddata != '' && ((_c = element.compareWith) === null || _c === void 0 ? void 0 : _c.contains.toString().includes(comparedfielddata))) {
                                visiblityMap.set(index, false);
                            }
                            else if (comparedfielddata != '' && comparedfielddata == ((_d = element.compareWith) === null || _d === void 0 ? void 0 : _d.contains)) {
                                visiblityMap.set(index, false);
                            }
                        }
                        else if ((_e = element.compareWith) === null || _e === void 0 ? void 0 : _e.notContains) {
                            if (comparedfielddata != '' && !((_f = element.compareWith) === null || _f === void 0 ? void 0 : _f.notContains.toString().includes(comparedfielddata.toString()))) {
                                visiblityMap.set(index, false);
                            }
                            else if (comparedfielddata != '' && !((_g = element.compareWith) === null || _g === void 0 ? void 0 : _g.notContains.toString().includes('[')) && comparedfielddata != ((_h = element.compareWith) === null || _h === void 0 ? void 0 : _h.notContains)) {
                                visiblityMap.set(index, false);
                            }
                        }
                        else if (((_j = element.compareWith) === null || _j === void 0 ? void 0 : _j.minValue) && comparedfielddata && Number(comparedfielddata) > ((_k = element.compareWith) === null || _k === void 0 ? void 0 : _k.minValue)) {
                            visiblityMap.set(index, false);
                        }
                        else if (((_l = element.compareWith) === null || _l === void 0 ? void 0 : _l.minValue) && Number(comparedfielddata) > ((_m = element.compareWith) === null || _m === void 0 ? void 0 : _m.maxValue)) {
                            visiblityMap.set(index, false);
                        }
                    }
                    else {
                        const altval = (_o = answerMap.get(fieldid)) === null || _o === void 0 ? void 0 : _o.altValue;
                        if (!altval || altval == 'undefined')
                            visiblityMap.set(index, false);
                    }
                }
            }
            if (item && (item === null || item === void 0 ? void 0 : item.orConditions)) {
                for (let index = 0; index < (item === null || item === void 0 ? void 0 : item.orConditions.length); index++) {
                    const element = item === null || item === void 0 ? void 0 : item.orConditions[index];
                    const fieldid = element.fieldId;
                    let comparedfielddata = '';
                    if (answerMap.get(fieldid)) {
                        const ansobject = answerMap.get(fieldid);
                        comparedfielddata = (ansobject === null || ansobject === void 0 ? void 0 : ansobject.value) || '';
                    }
                    orvisiblityMap.set(index, true);
                    if (element.compareWith) {
                        if (comparedfielddata == ((_p = element.compareWith) === null || _p === void 0 ? void 0 : _p.extactValue)) { // hidden = false;
                            orvisiblityMap.set(index, false);
                        }
                        else if ((_q = element.compareWith) === null || _q === void 0 ? void 0 : _q.contains) {
                            if (comparedfielddata != '' && JSON.stringify((_r = element.compareWith) === null || _r === void 0 ? void 0 : _r.contains).includes(comparedfielddata)) { // hidden =false;
                                orvisiblityMap.set(index, false);
                            }
                            else if (comparedfielddata != '' && comparedfielddata == ((_s = element.compareWith) === null || _s === void 0 ? void 0 : _s.contains)) {
                                orvisiblityMap.set(index, false);
                            }
                        }
                        else if ((_t = element.compareWith) === null || _t === void 0 ? void 0 : _t.notContains) {
                            if (!((_u = element.compareWith) === null || _u === void 0 ? void 0 : _u.notContains.toString().includes(comparedfielddata.toString()))) {
                                orvisiblityMap.set(index, false);
                            }
                            else if (comparedfielddata != ((_v = element.compareWith) === null || _v === void 0 ? void 0 : _v.notContains)) {
                                orvisiblityMap.set(index, false);
                            }
                        }
                        else if (((_w = element.compareWith) === null || _w === void 0 ? void 0 : _w.minValue) && comparedfielddata && Number(comparedfielddata) > ((_x = element.compareWith) === null || _x === void 0 ? void 0 : _x.minValue)) {
                            orvisiblityMap.set(index, false);
                        }
                        else if (((_y = element.compareWith) === null || _y === void 0 ? void 0 : _y.minValue) && Number(comparedfielddata) > ((_z = element.compareWith) === null || _z === void 0 ? void 0 : _z.maxValue)) {
                            orvisiblityMap.set(index, false);
                        }
                    }
                    else {
                        const altval = (_0 = answerMap.get(fieldid)) === null || _0 === void 0 ? void 0 : _0.altValue;
                        if (!altval || altval == 'undefined')
                            visiblityMap.set(index, false);
                    }
                }
            }
            let hidden = false;
            let con = false;
            visiblityMap.forEach((el) => {
                if (el && !con)
                    con = true;
            });
            let orcon = true; /// if one is false then false
            if (orvisiblityMap.size > 0)
                orvisiblityMap.forEach((el) => {
                    if (!el && orcon)
                        orcon = false;
                });
            else
                orcon = false;
            hidden = con || orcon;
            // return hidden;
            ConfigConditionMap.set(i, hidden);
        }
        let configIdToReturn = "";
        if (ConfigConditionMap.size > 0)
            ConfigConditionMap.forEach((el, index) => {
                if (!el)
                    configIdToReturn = configConditions[index].configId;
            });
        return configIdToReturn;
    }
    checkVisibilityCondition(item, answerMap, type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
        let visiblityMap = new Map();
        let orvisiblityMap = new Map();
        if (item && ((_a = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _a === void 0 ? void 0 : _a.conditions.length)) {
            for (let index = 0; index < ((_b = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _b === void 0 ? void 0 : _b.conditions.length); index++) {
                const element = (_c = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _c === void 0 ? void 0 : _c.conditions[index];
                const fieldid = element.fieldId;
                let comparedfielddata = '';
                if (answerMap.get(fieldid)) {
                    const ansobject = answerMap.get(fieldid);
                    comparedfielddata = (ansobject === null || ansobject === void 0 ? void 0 : ansobject.value) || '';
                }
                visiblityMap.set(index, true);
                if (element.compareWith) {
                    if (comparedfielddata == ((_d = element.compareWith) === null || _d === void 0 ? void 0 : _d.extactValue)) {
                        visiblityMap.set(index, false);
                    }
                    else if ((_e = element.compareWith) === null || _e === void 0 ? void 0 : _e.contains) {
                        if (comparedfielddata != '' && ((_f = element.compareWith) === null || _f === void 0 ? void 0 : _f.contains.toString().includes(comparedfielddata))) {
                            visiblityMap.set(index, false);
                        }
                        else if (comparedfielddata != '' && comparedfielddata == ((_g = element.compareWith) === null || _g === void 0 ? void 0 : _g.contains)) {
                            visiblityMap.set(index, false);
                        }
                    }
                    else if ((_h = element.compareWith) === null || _h === void 0 ? void 0 : _h.notContains) {
                        if (comparedfielddata != '' && !((_j = element.compareWith) === null || _j === void 0 ? void 0 : _j.notContains.toString().includes(comparedfielddata.toString()))) {
                            visiblityMap.set(index, false);
                        }
                        else if (comparedfielddata != '' && !((_k = element.compareWith) === null || _k === void 0 ? void 0 : _k.notContains.toString().includes('[')) && comparedfielddata != ((_l = element.compareWith) === null || _l === void 0 ? void 0 : _l.notContains)) {
                            visiblityMap.set(index, false);
                        }
                    }
                    else if (((_m = element.compareWith) === null || _m === void 0 ? void 0 : _m.minValue) && comparedfielddata && Number(comparedfielddata) > ((_o = element.compareWith) === null || _o === void 0 ? void 0 : _o.minValue)) {
                        visiblityMap.set(index, false);
                    }
                    else if (((_p = element.compareWith) === null || _p === void 0 ? void 0 : _p.minValue) && Number(comparedfielddata) > ((_q = element.compareWith) === null || _q === void 0 ? void 0 : _q.maxValue)) {
                        visiblityMap.set(index, false);
                    }
                }
                else {
                    const altval = (_r = answerMap.get(fieldid)) === null || _r === void 0 ? void 0 : _r.altValue;
                    if (!altval || altval == 'undefined')
                        visiblityMap.set(index, false);
                }
            }
        }
        if (item && ((_s = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _s === void 0 ? void 0 : _s.orConditions.length)) {
            for (let index = 0; index < ((_t = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _t === void 0 ? void 0 : _t.orConditions.length); index++) {
                const element = (_u = item === null || item === void 0 ? void 0 : item.visibilityCondition) === null || _u === void 0 ? void 0 : _u.orConditions[index];
                const fieldid = element.fieldId;
                let comparedfielddata = '';
                if (answerMap.get(fieldid)) {
                    const ansobject = answerMap.get(fieldid);
                    comparedfielddata = (ansobject === null || ansobject === void 0 ? void 0 : ansobject.value) || '';
                }
                orvisiblityMap.set(index, true);
                if (element.compareWith) {
                    if (comparedfielddata == ((_v = element.compareWith) === null || _v === void 0 ? void 0 : _v.extactValue)) { // hidden = false;
                        orvisiblityMap.set(index, false);
                    }
                    else if ((_w = element.compareWith) === null || _w === void 0 ? void 0 : _w.contains) {
                        if (comparedfielddata != '' && JSON.stringify((_x = element.compareWith) === null || _x === void 0 ? void 0 : _x.contains).includes(comparedfielddata)) { // hidden =false;
                            orvisiblityMap.set(index, false);
                        }
                        else if (comparedfielddata != '' && comparedfielddata == ((_y = element.compareWith) === null || _y === void 0 ? void 0 : _y.contains)) {
                            orvisiblityMap.set(index, false);
                        }
                    }
                    else if ((_z = element.compareWith) === null || _z === void 0 ? void 0 : _z.notContains) {
                        if (!((_0 = element.compareWith) === null || _0 === void 0 ? void 0 : _0.notContains.toString().includes(comparedfielddata.toString()))) {
                            orvisiblityMap.set(index, false);
                        }
                        else if (comparedfielddata != ((_1 = element.compareWith) === null || _1 === void 0 ? void 0 : _1.notContains)) {
                            orvisiblityMap.set(index, false);
                        }
                    }
                    else if (((_2 = element.compareWith) === null || _2 === void 0 ? void 0 : _2.minValue) && comparedfielddata && Number(comparedfielddata) > ((_3 = element.compareWith) === null || _3 === void 0 ? void 0 : _3.minValue)) {
                        orvisiblityMap.set(index, false);
                    }
                    else if (((_4 = element.compareWith) === null || _4 === void 0 ? void 0 : _4.minValue) && Number(comparedfielddata) > ((_5 = element.compareWith) === null || _5 === void 0 ? void 0 : _5.maxValue)) {
                        orvisiblityMap.set(index, false);
                    }
                }
                else {
                    const altval = (_6 = answerMap.get(fieldid)) === null || _6 === void 0 ? void 0 : _6.altValue;
                    if (!altval || altval == 'undefined')
                        visiblityMap.set(index, false);
                }
            }
        }
        let hidden = false;
        let con = false;
        visiblityMap.forEach((el) => {
            if (el && !con)
                con = true;
        });
        let orcon = true; /// if one is false then false
        if (orvisiblityMap.size > 0)
            orvisiblityMap.forEach((el) => {
                if (!el && orcon)
                    orcon = false;
            });
        else
            orcon = false;
        hidden = con || orcon;
        return hidden;
    }
    formatCurrencyRounOF(cur) {
        let fc = new Intl.NumberFormat('en-US');
        return '$' + fc.format(Math.ceil(cur));
    }
    transformTitle(value) {
        let first = value.substr(0, 1).toUpperCase();
        return first + value.substr(1);
    }
    formatCurrency(cur) {
        let fc = new Intl.NumberFormat('en-US');
        return '$' + fc.format(cur);
    }
    formatNumberInUsaFormat(num) {
        let fc = new Intl.NumberFormat('en-US');
        return fc.format(num);
    }
    getDayName(date) {
        return moment(date).format('dddd');
    }
    formatNumerWithType(num, type) {
        // 
        if (type === 'USA') {
            if (num.length > 3)
                num = num.replace(/.{3}/, '$&-');
            if (num.length > 7)
                num = num.replace(/.{7}/, '$&-');
        }
        return num;
    }
    getDateFromTimeinms(tms) {
        const dateString = moment(tms).format('D');
        return dateString;
    }
    getMonthFromTimeinms(tms) {
        const dateString = moment(tms).format('MM');
        return dateString;
    }
    getYearFromTimeinms(tms) {
        const dateString = moment(tms).format('YYYY');
        return dateString;
    }
    gettoayName() {
        return moment().format('dddd');
    }
    getPreviousDay(count) {
        return moment().subtract(count, 'day').format('LL');
    }
    getUpcomingDayname(count) {
        return moment().add(count, 'day').format('LL');
    }
    formatNumber(num, count) {
        return num.toString().padStart(count, "0"); //1 will be converted in 0001
    }
    dateToIsoFormat(date, format) {
        return (moment(date, format).toISOString());
    }
    dateutcIsoFormat(date, format) {
        // moment.utc('05-06-2018', 'MM-DD-YYYY').format();
        return moment.utc(date, format).toISOString();
    }
    formatDate(date, format) {
        switch (format) {
            case 'MM/DD/YYYY': {
                return moment(date).format('MM/DD/YYYY');
                break;
            }
            case 'MM-DD-YYYY': {
                return moment(date).format('MM-DD-YYYY');
                break;
            }
            case 'YYYY-MM': {
                return moment(date).format('YYYY-MM');
                break;
            }
            case 'YYYY/MM': {
                return moment(date).format('YYYY/MM');
                break;
            }
            case 'YYYY': {
                return moment(date).format('YYYY');
                break;
            }
            case 'dddd': {
                return moment(date).format('dddd'); // Wednesday
                break;
            }
            case 'MMM Do YY': {
                return moment(date).format('MMM Do YY'); // Apr 14th 21
                break;
            }
            case 'YYYY [escaped] YYYY': {
                return moment(date).format('YYYY [escaped] YYYY');
                break;
            }
            case 'MMMM Do YYYY, h:mm:ss a': {
                return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                break;
            }
            default: {
                return moment(date).format();
                break;
            }
        }
    }
    getBrowserName() {
        const agent = window.navigator.userAgent.toLowerCase();
        switch (true) {
            case agent.indexOf('edge') > -1:
                return 'edge';
            case agent.indexOf('opr') > -1 && !!window.opr:
                return 'opera';
            case agent.indexOf('chrome') > -1 && !!window.chrome:
                return 'chrome';
            case agent.indexOf('trident') > -1:
                return 'ie';
            case agent.indexOf('firefox') > -1:
                return 'firefox';
            case agent.indexOf('safari') > -1:
                return 'safari';
            default:
                return 'other';
        }
    }
}
CodehelpService.ɵfac = function CodehelpService_Factory(t) { return new (t || CodehelpService)(); };
CodehelpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CodehelpService, factory: CodehelpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CodehelpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var ConditionName;
(function (ConditionName) {
    ConditionName[ConditionName["DISABLED"] = 0] = "DISABLED";
    ConditionName[ConditionName["HIDDEN"] = 1] = "HIDDEN";
    ConditionName[ConditionName["SHOWN"] = 2] = "SHOWN";
    ConditionName[ConditionName["ENABLED"] = 3] = "ENABLED";
})(ConditionName || (ConditionName = {}));
var ReqMethod;
(function (ReqMethod) {
    ReqMethod[ReqMethod["GET"] = 0] = "GET";
    ReqMethod[ReqMethod["POST"] = 1] = "POST";
    ReqMethod[ReqMethod["PUT"] = 2] = "PUT";
    ReqMethod[ReqMethod["DELETE"] = 3] = "DELETE";
    ReqMethod[ReqMethod["AUTH"] = 4] = "AUTH";
    ReqMethod[ReqMethod["SEARCH"] = 5] = "SEARCH";
    ReqMethod[ReqMethod["UPLOAD"] = 6] = "UPLOAD";
    ReqMethod[ReqMethod["CDNGET"] = 7] = "CDNGET";
    ReqMethod[ReqMethod["DELETEWITHREQUEST"] = 8] = "DELETEWITHREQUEST";
})(ReqMethod || (ReqMethod = {}));
var envMode;
(function (envMode) {
    envMode[envMode["PROD"] = 0] = "PROD";
    envMode[envMode["DEBUG"] = 1] = "DEBUG";
    envMode[envMode["OTHER"] = 2] = "OTHER";
})(envMode || (envMode = {}));
var InputType;
(function (InputType) {
    // AUTO_COMPLETE = "AUTO_COMPLETE",
    // SINGLE_SELECT_CHECKBOX = "SINGLE_SELECT_CHECKBOX",
    // TEXT = "TEXT",
    // TEXT_MULTILINE = "TEXT_MULTILINE",
    // NUMBER = "NUMBER",
    // DROPDOWN = "DROPDOWN",
    // MULTI_SELECT_CHECKBOX = "MULTI_SELECT_CHECKBOX",
    // CHECKBOX = "CHECKBOX",
    // DATE = "DATE",
    // HEADING = "HEADING"
    InputType["TEXT"] = "TEXT";
    InputType["TEXT_MULTILINE"] = "TEXT_MULTILINE";
    InputType["STAR_5_RATING"] = "STAR_5_RATING";
    InputType["STAR_3_RATING"] = "STAR_3_RATING";
    InputType["STAR_10_RATING"] = "STAR_10_RATING";
    InputType["DATE"] = "DATE";
    InputType["NUMBER"] = "NUMBER";
    InputType["FILE"] = "FILE";
    InputType["DROPDOWN"] = "DROPDOWN";
    InputType["SINGLE_SELECT_CHECKBOX"] = "SINGLE_SELECT_CHECKBOX";
    InputType["MULTI_SELECT_CHECKBOX"] = "MULTI_SELECT_CHECKBOX";
    InputType["CHECKBOX"] = "CHECKBOX";
    InputType["AUTO_COMPLETE"] = "AUTO_COMPLETE";
    InputType["HEADING"] = "HEADING";
    InputType["OPEN_ANOTHER_FORM"] = "OPEN_ANOTHER_FORM";
    InputType["DROPDOWN_SEARCH"] = "DROPDOWN_SEARCH";
    InputType["TEXT_PLUS_LINK"] = "TEXT_PLUS_LINK";
    InputType["SINGLE_SELECT_TAB_BUTTON"] = "SINGLE_SELECT_TAB_BUTTON";
    InputType["MULTI_SELECT_TAB_BUTTON"] = "MULTI_SELECT_TAB_BUTTON";
})(InputType || (InputType = {}));

class HttpService {
    constructor(http, codeHelp, router, notificationsService) {
        this.http = http;
        this.codeHelp = codeHelp;
        this.router = router;
        this.notificationsService = notificationsService;
        this.endpoint = CONFIG.url;
    }
    setEndPoint(type, url) {
        if (type === envMode.PROD)
            this.endpoint = CONFIG.prodUrl;
        else if (type === envMode.OTHER && url)
            this.endpoint = url;
        else
            this.endpoint = CONFIG.techUrl;
    }
    getEndPoint() {
        return this.endpoint;
    }
    getAuthToken() {
        const pretext = CONFIG.preText;
        // console.log(CONFIG.preText)
        if (pretext)
            return localStorage.getItem(pretext + "authToken");
        else
            return localStorage.getItem("authToken");
    }
    search(path, query, isSetAppHeader) {
        return this.callApi(ReqMethod.SEARCH, path, '', query, isSetAppHeader);
    }
    getCdn(path, id, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('path',path)
            return this.callApi(ReqMethod.CDNGET, path, id, isSetAppHeader);
        });
    }
    get(path, id, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.GET, path, id, isSetAppHeader);
        });
    }
    checkStatus() {
        return this.http.get(CONFIG.url + `status`, { responseType: "text" }).toPromise();
    }
    auth(path, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.AUTH, path, '', payload, isSetAppHeader);
        });
    }
    post(path, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.POST, path, '', payload, isSetAppHeader);
        });
    }
    put(path, id, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.PUT, path, id, payload, isSetAppHeader);
        });
    }
    upload(path, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.UPLOAD, path, '', payload, isSetAppHeader);
        });
    }
    delete(path, id, isSetAppHeader) {
        return this.callApi(ReqMethod.DELETE, path, id, isSetAppHeader);
    }
    deleteWithRequest(path, id, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.callApi(ReqMethod.DELETEWITHREQUEST, path, id, payload, isSetAppHeader);
        });
    }
    downloadPdf(path, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.http
                .post(this.endpoint + `${path}`, payload, { headers: { 'Accept': 'application/pdf' } })
                .toPromise();
        });
    }
    callApi(method, path, id, payload, isSetAppHeader) {
        return __awaiter(this, void 0, void 0, function* () {
            let authToken = '';
            try {
                authToken = this.getAuthToken();
            }
            catch (e) {
                authToken = '';
            }
            let HEADER = {
                'headers': {
                    "content-type": "application/json",
                    // 'authorization': 'Bearer ' + this.authToken
                },
            };
            if (isSetAppHeader || CONFIG.virtueSecretToken === authToken) {
                HEADER = {
                    'headers': {
                        "content-type": "application/json",
                        "app-head": CONFIG.virtueSecretToken
                    },
                };
            }
            else if (authToken) {
                HEADER = {
                    'headers': {
                        "content-type": "application/json",
                        "authorization": 'Bearer ' + authToken
                    },
                };
            }
            let HEADER_UNSECURE = {
                'headers': {
                    "content-type": "application/json"
                },
            };
            try {
                switch (method) {
                    case ReqMethod.AUTH:
                        return yield this.http
                            .post(this.endpoint + `${path}`, JSON.stringify(payload), HEADER_UNSECURE)
                            .toPromise();
                    case ReqMethod.UPLOAD:
                        return this.http
                            .post(this.endpoint + `${path}` + `/upload`, payload)
                            .toPromise();
                    case ReqMethod.SEARCH:
                        return this.http
                            .post(this.endpoint + `${path}` + `/search`, payload, HEADER)
                            .toPromise();
                    case ReqMethod.POST:
                        return yield this.http
                            .post(this.endpoint + `${path}`, payload, HEADER)
                            .toPromise();
                    case ReqMethod.CDNGET: {
                        HEADER = {
                            'headers': {
                                "content-type": "text/plain"
                            },
                        };
                        return yield this.http.get(path, HEADER).toPromise();
                    }
                    case ReqMethod.GET: {
                        if (id != '')
                            return yield this.http.get(this.endpoint + `${path}` + `/${id}`, HEADER).toPromise();
                        else
                            return yield this.http.get(this.endpoint + `${path}`, HEADER).toPromise();
                    }
                    case ReqMethod.DELETEWITHREQUEST: {
                        const payloadOptions = {
                            headers: new HttpHeaders({
                                'Content-Type': 'application/json',
                                'Accept': 'text/plain',
                            }),
                            body: payload
                        };
                        return yield this.http.delete(this.endpoint + `${path}` + `/${id}`, payloadOptions).toPromise();
                    }
                    case ReqMethod.PUT:
                        return yield this.http
                            .put(this.endpoint + `${path}/` + id, payload, HEADER)
                            .toPromise();
                    case ReqMethod.DELETE:
                        return yield this.http.delete(this.endpoint + `${path}/` + id, HEADER).toPromise();
                }
            }
            catch (e) {
                if (e.status == 401) {
                    // this.notificationsService.show('Access not allowed, Please login', {
                    //     label: 'Unauthorised Access'
                    // })
                    //     .toPromise();
                    // // localStorage.removeItem('auth');
                    // localStorage.removeItem('username');
                    // localStorage.removeItem('LoginInfo');
                    // localStorage.removeItem('isLoggedIn');
                    // this.setAuthToken('');
                    this.codeHelp.resetUserInfoLogout();
                    this.router.navigate([CONFIG.baseUrl + CONFIG.loginUrl]);
                }
                //
                //
                throw e;
            }
        });
    }
    // getRequest(path:string){
    //   return this.http.get(CONFIG.url+path);
    // }
    // postRequest(path: string,data:any){
    //   let headersObj = new HttpHeaders({ 'Content-Type': "application/json"});
    //   return this.http.post(CONFIG.url+path,data,{ headers: headersObj });   
    // }
    // searchRequest(path: string,data:any){
    //   let headersObj = new HttpHeaders({ 'Content-Type': "application/json"});
    //   return this.http.post(CONFIG.url+path+'/search',data,{ headers: headersObj });   
    // }
    // putRequest(path: string,data:any){
    //   let headersObj = new HttpHeaders({ 'Content-Type': "application/json"});
    //   return this.http.put(CONFIG.url+path,data,{ headers: headersObj });   
    // }
    // postRequestwithToken(path: string,data:any){
    //   let headersObj = new HttpHeaders({ 'Content-Type': "application/json",
    //                                   'Authorization' : 'Bearer '+localStorage.get('token') });
    //   return this.http.post(CONFIG.url+path,data,{ headers: headersObj });   
    // }
    setToken(token) {
        localStorage.set('token', token).then(function () {
            return true;
        });
    }
    getHost() {
        return this.endpoint;
    }
    getToken() {
        return localStorage.get('token');
    }
}
HttpService.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(CodehelpService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(TuiNotificationsService)); };
HttpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HttpService, factory: HttpService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: CodehelpService }, { type: i3.Router }, { type: i4.TuiNotificationsService, decorators: [{
                type: Inject,
                args: [TuiNotificationsService]
            }] }]; }, null); })();

class ConfigMapService {
    constructor(httpser, codehelp) {
        this.httpser = httpser;
        this.codehelp = codehelp;
        this.configMap = new Map();
        this.providerId = this.codehelp.getProviderID() || '';
    }
    setProviderPoint(type) {
        if (type === envMode.PROD)
            this.commonProviderId = CONFIG.virtueProdProviderId;
        else if (type === envMode.OTHER)
            this.commonProviderId = this.providerId;
        else
            this.commonProviderId = CONFIG.virtueTechProviderId;
    }
    getRealtimeConfigData(id, fieldId, callback, isSetAppHeader) {
        this.providerId = this.codehelp.getProviderID() || '';
        let respvalue;
        const url = 'fieldConfig';
        let body = {
            configId: id,
            providerId: this.providerId,
        };
        if (fieldId == 224 || fieldId == 239 || fieldId == 6 || fieldId == 265 || id == 'feedbackType') {
            body.providerId = this.commonProviderId;
        }
        this.httpser.search(url, body, isSetAppHeader).then((response) => {
            respvalue = response;
            this.configMap.set(id, respvalue);
            callback(respvalue);
        });
    }
    getVirtueConfigData(id, fieldId, callback, isSetAppHeader) {
        this.providerId = this.codehelp.getProviderID() || '';
        let respvalue;
        if (id && id != '') {
            if (this.configMap && this.configMap.get(id)) {
                respvalue = this.configMap.get(id) || [];
                callback(respvalue);
            }
            else {
                let respvalue;
                const url = 'fieldConfig';
                let body = {
                    configId: id,
                    providerId: this.commonProviderId
                };
                this.httpser.search(url, body, isSetAppHeader).then((response) => {
                    respvalue = response;
                    this.configMap.set(id, respvalue);
                    callback(respvalue);
                });
            }
        }
        else {
            callback([]);
        }
    }
    getConfigData(id, fieldId, callback, isSetAppHeader) {
        // if(!this.providerId)
        this.providerId = this.codehelp.getProviderID() || '';
        let respvalue;
        if (id && id != '') {
            if (this.configMap && this.configMap.get(id)) {
                respvalue = this.configMap.get(id) || [];
                callback(respvalue);
            }
            else {
                const url = 'fieldConfig';
                let body = {
                    configId: id,
                    providerId: this.providerId,
                };
                if (fieldId == 224 || fieldId == 239 || fieldId == 6 || fieldId == 265 || id == 'feedbackType') {
                    body.providerId = this.commonProviderId;
                }
                this.httpser.search(url, body, isSetAppHeader).then((response) => {
                    respvalue = response;
                    this.configMap.set(id, respvalue);
                    callback(respvalue);
                });
            }
        }
        else {
            callback([]);
        }
    }
}
ConfigMapService.ɵfac = function ConfigMapService_Factory(t) { return new (t || ConfigMapService)(i0.ɵɵinject(HttpService), i0.ɵɵinject(CodehelpService)); };
ConfigMapService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigMapService, factory: ConfigMapService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigMapService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpService }, { type: CodehelpService }]; }, null); })();

function DateDialogComponent_tui_calendar_month_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-calendar-month", 3);
    i0.ɵɵlistener("monthClick", function DateDialogComponent_tui_calendar_month_1_Template_tui_calendar_month_monthClick_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.onMonthClick($event); })("yearChange", function DateDialogComponent_tui_calendar_month_1_Template_tui_calendar_month_yearChange_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.activeYear = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("min", ctx_r0.min)("max", ctx_r0.max)("year", ctx_r0.activeYear);
} }
function DateDialogComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-calendar", 4);
    i0.ɵɵlistener("dayClick", function DateDialogComponent_ng_template_2_Template_tui_calendar_dayClick_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.onDayClick($event); })("monthChange", function DateDialogComponent_ng_template_2_Template_tui_calendar_monthChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.activeMonth = $event; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("min", ctx_r2.minCal)("month", ctx_r2.activeMonth)("max", ctx_r2.maxCal);
} }
class DateDialogComponent {
    constructor(dialogService, context, codeHelp) {
        this.dialogService = dialogService;
        this.context = context;
        this.codeHelp = codeHelp;
        this.value = '';
        this.name = '';
        this.maxCal = new TuiDay(2021, 12, 12);
        this.minCal = new TuiDay(1987, 12, 12);
        this.activeMonth = new TuiMonth(2021, 7);
        this.activeYear = new TuiYear(2017);
        this.showmonth = true;
        const mindateIp = this.codeHelp.getDateFromTimeinms(Number(this.data.min));
        const minmonthIp = this.codeHelp.getMonthFromTimeinms(Number(this.data.min));
        const minyearIp = this.codeHelp.getYearFromTimeinms(Number(this.data.min));
        const maxdateIp = this.codeHelp.getDateFromTimeinms(Number(this.data.max));
        const maxmonthIp = this.codeHelp.getMonthFromTimeinms(Number(this.data.max));
        const maxyearIp = this.codeHelp.getYearFromTimeinms(Number(this.data.max));
        this.activeYear = new TuiYear(Number(maxyearIp));
        // console.log(maxyearIp+"max",maxmonthIp);
        // console.log(minyearIp+"min",minmonthIp)
        this.max = new TuiMonth(Number(maxyearIp), Number(maxmonthIp));
        this.min = new TuiMonth(Number(minyearIp), Number(minmonthIp));
        this.minCal = new TuiDay(Number(minyearIp), Number(minmonthIp), Number(mindateIp));
        this.maxCal = new TuiDay(Number(maxyearIp), Number(maxmonthIp), Number(maxdateIp));
        this.activeMonth = new TuiMonth(Number(maxyearIp), Number(maxmonthIp) - 1);
    }
    ngOnInit() {
        //data =
        // this.codeHelp.
        const ln = (this.data.dateformat.toString().match(new RegExp('d', 'g')) || []).length;
        // console.log('this.data',this.data.dateformat.toString().includes('dd'));
        // console.log('this.dataDD',this.data.dateformat.toString().includes('DD'));
        if (this.data.dateformat.toString().includes('dd') || this.data.dateformat.toString().includes('DD'))
            this.showmonth = false;
        // if(ln== 2){
        //   this.showmonth= true;
        // }
    }
    get hasValue() {
        return this.value !== null;
    }
    get data() {
        return this.context.data;
    }
    submit() {
        if (this.value !== null) {
            this.data.value = this.value;
            this.context.completeWith(this.data);
        }
    }
    showDialog(content) {
        this.dialogService.open(content, { dismissible: true }).subscribe();
    }
    onDayClick(day) {
        if (day.month < 12)
            this.value = day.year + '-' + ('0' + (day.month + 1)).slice(-2) + '-' + ('0' + (day.day)).slice(-2); //day.day; 
        else
            this.value = day.year + '-' + ('0' + (day.month)).slice(-2) + '-' + ('0' + (day.day)).slice(-2); //day.day; 
        this.data.value = this.codeHelp.formatDate(this.value, this.data.dateformat.toString()); //  this.value;
        this.context.completeWith(this.data);
    }
    onMonthClick(month) {
        this.value = month.year + '-' + ('0' + (month.month + 1)).slice(-2); //month.month; 
        this.data.value = this.codeHelp.formatDate(this.value, this.data.dateformat.toString()); //  this.value;
        this.context.completeWith(this.data);
    }
}
DateDialogComponent.ɵfac = function DateDialogComponent_Factory(t) { return new (t || DateDialogComponent)(i0.ɵɵdirectiveInject(TuiDialogService), i0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), i0.ɵɵdirectiveInject(CodehelpService)); };
DateDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DateDialogComponent, selectors: [["lib-date-dialog"]], decls: 4, vars: 2, consts: [[1, "flex", "justify-center", "fm-dob"], [3, "min", "max", "year", "monthClick", "yearChange", 4, "ngIf", "ngIfElse"], ["fullcalendar", ""], [3, "min", "max", "year", "monthClick", "yearChange"], [3, "min", "month", "max", "dayClick", "monthChange"]], template: function DateDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DateDialogComponent_tui_calendar_month_1_Template, 1, 3, "tui-calendar-month", 1);
        i0.ɵɵtemplate(2, DateDialogComponent_ng_template_2_Template, 1, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showmonth)("ngIfElse", _r1);
    } }, directives: [i4$1.NgIf, i5.TuiCalendarMonthComponent, i4.TuiCalendarComponent], styles: ["section{display:flex!important;justify-content:center}  .content .heading{text-align:center!important}  .t-content .t-heading{text-align:center!important}  .fm-dob .content{display:block!important}  .fm-dob .t-content{display:block!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-date-dialog',
                templateUrl: './date-dialog.component.html',
                styleUrls: ['./date-dialog.component.css']
            }]
    }], function () { return [{ type: i4.TuiDialogService, decorators: [{
                type: Inject,
                args: [TuiDialogService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: CodehelpService }]; }, null); })();

class SafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = function SafeUrlPipe_Factory(t) { return new (t || SafeUrlPipe)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer, 16)); };
SafeUrlPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safeUrl", type: SafeUrlPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeUrl'
            }]
    }], function () { return [{ type: i1$1.DomSanitizer }]; }, null); })();

const _c0$1 = ["inpIframeId"];
// import * as $ from 'jquery';
class EfcDialogComponent {
    constructor(dialogService, context, httpSer) {
        this.dialogService = dialogService;
        this.context = context;
        this.httpSer = httpSer;
        this.value = null;
        this.name = '';
        this.efcURL = ""; //"http://localhost:4200/login/keuka";//"https://tech.virtueanalytics.com/efcApp/EFC";
        if (this.httpSer.getEndPoint() === CONFIG.techUrl)
            this.efcURL = CONFIG.saiUrl;
        else
            this.efcURL = CONFIG.prodSAIUrl;
    }
    ngOnInit() {
        throw new Error('Method not implemented.');
    }
    getIframeInnerValue() {
        var _a, _b, _c, _d, _e;
        console.log((_a = this.iframe) === null || _a === void 0 ? void 0 : _a.nativeElement);
        console.log((_b = this.iframe) === null || _b === void 0 ? void 0 : _b.nativeElement.contentWindow);
        // console.log(this.iframe?.nativeElement.contentWindow.document); 
        // console.log(this.iframe?.nativeElement.contentWindow.document.getElementById('userName').value);
        // console.log(this.iframe?.nativeElement.contentWindow.document.body.innerHTML);
        // console.log(this.iframe?.nativeElement.contentWindow.document.body.innerHTML.find('#userName'));
        // console.log(this.iframe?.nativeElement.contentWindow.find("#userName"));
        // this.context.completeWith(this.iframe?.nativeElement.contentWindow.document.getElementById('userName').value.toString());
        try {
            const efcVal = (_e = (_d = (_c = this.iframe) === null || _c === void 0 ? void 0 : _c.nativeElement.contentWindow) === null || _d === void 0 ? void 0 : _d.document) === null || _e === void 0 ? void 0 : _e.getElementById('efcamount').value;
            // var getIframeVal = $('iframe[name=inpIframe]').contents().find('#efcamount').val();
            if (efcVal.toString()) {
                const val = Math.ceil(Number(efcVal.toString()));
                this.context.completeWith(val.toString());
            }
            else {
                this.context.completeWith('0');
            }
        }
        catch (error) {
            console.log(error);
            this.context.completeWith('0');
        }
    }
    get hasValue() {
        return this.value !== null;
    }
    get data() {
        return this.context.data;
    }
    submit() {
        if (this.value !== null) {
            this.context.completeWith(this.value);
        }
    }
    showDialog(content) {
        this.dialogService.open(content, { dismissible: true }).subscribe();
    }
}
EfcDialogComponent.ɵfac = function EfcDialogComponent_Factory(t) { return new (t || EfcDialogComponent)(i0.ɵɵdirectiveInject(TuiDialogService), i0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), i0.ɵɵdirectiveInject(HttpService)); };
EfcDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EfcDialogComponent, selectors: [["lib-efc-dialog"]], viewQuery: function EfcDialogComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.iframe = _t.first);
    } }, decls: 8, vars: 3, consts: [[1, "efc-dialog-close"], ["version", "1.1", "id", "Capa_1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 252 252", 0, "xml", "space", "preserve", 1, "dialog-efcsvg", 2, "enable-background", "new 0 0 252 252", 3, "click"], ["d", "M126,0C56.523,0,0,56.523,0,126s56.523,126,126,126s126-56.523,126-126S195.477,0,126,0z M126,234\n    \t\tc-59.551,0-108-48.449-108-108S66.449,18,126,18s108,48.449,108,108S185.551,234,126,234z"], ["d", "M164.612,87.388c-3.515-3.515-9.213-3.515-12.728,0L126,113.272l-25.885-25.885c-3.515-3.515-9.213-3.515-12.728,0\n    \t\tc-3.515,3.515-3.515,9.213,0,12.728L113.272,126l-25.885,25.885c-3.515,3.515-3.515,9.213,0,12.728\n    \t\tc1.757,1.757,4.061,2.636,6.364,2.636s4.606-0.879,6.364-2.636L126,138.728l25.885,25.885c1.757,1.757,4.061,2.636,6.364,2.636\n    \t\ts4.606-0.879,6.364-2.636c3.515-3.515,3.515-9.213,0-12.728L138.728,126l25.885-25.885\n    \t\tC168.127,96.601,168.127,90.902,164.612,87.388z"], ["name", "inpIframe", "id", "inpIframeId", 2, "height", "600px", "width", "100%", 3, "src"], ["inpIframeId", ""]], template: function EfcDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(1, "svg", 1);
        i0.ɵɵlistener("click", function EfcDialogComponent_Template__svg_svg_click_1_listener() { return ctx.getIframeInnerValue(); });
        i0.ɵɵelementStart(2, "g");
        i0.ɵɵelement(3, "path", 2);
        i0.ɵɵelement(4, "path", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(5, "iframe", 4, 5);
        i0.ɵɵpipe(7, "safeUrl");
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("src", i0.ɵɵpipeBind1(7, 1, ctx.efcURL), i0.ɵɵsanitizeResourceUrl);
    } }, pipes: [SafeUrlPipe], styles: [".dialog-efcsvg[_ngcontent-%COMP%]{height:30px;width:30px}.dialog-efcsvg[_ngcontent-%COMP%]:hover{cursor:pointer}.efc-dialog-close[_ngcontent-%COMP%]{position:absolute;right:6px;top:6px}  section{display:block!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EfcDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-efc-dialog',
                templateUrl: './efc-dialog.component.html',
                styleUrls: ['./efc-dialog.component.css']
            }]
    }], function () { return [{ type: i4.TuiDialogService, decorators: [{
                type: Inject,
                args: [TuiDialogService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: HttpService }]; }, { iframe: [{
            type: ViewChild,
            args: ['inpIframeId']
        }] }); })();

function ChooseToCalulateEFCDialogComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3, "EFC Result : ");
    i0.ɵɵelementStart(4, "b");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.formatCur(ctx_r0.efcValue));
} }
class ChooseToCalulateEFCDialogComponent {
    constructor(cdRef, dialogService, context, httpSer, codehelp) {
        this.cdRef = cdRef;
        this.dialogService = dialogService;
        this.context = context;
        this.httpSer = httpSer;
        this.codehelp = codehelp;
        this.labelOutside = true;
        this.disabled = false;
        this.chooseArrayList = [
            { value: 1, label: 'AGI' },
            { value: 2, label: 'Virtue EFC Calculator' },
        ];
        this.selectedOption = 1;
        this.placeholder = 'Enter Adjusted Gross Income';
        this.taxFiler = true;
        this.isLoading = false;
        this.AGImodelvalue = undefined;
        this.efcValue = 0;
        this.isShowEFCResult = false;
        this.studentStateCode = '';
        console.log('State Context Data', context);
        let data = context.data;
        if (data === null || data === void 0 ? void 0 : data.value) {
            this.studentStateCode = data === null || data === void 0 ? void 0 : data.value;
            console.log('studentStateCode', this.studentStateCode);
        }
    }
    ngOnInit() { }
    changeAGI(val) {
        if (val) {
            console.log('Inside', val);
        }
    }
    changeTaxFiler(val) {
        this.taxFiler = val;
        if (val == true) {
            this.placeholder = "Enter Adjusted Gross Income";
        }
        else {
            this.placeholder = "Enter Family Income from Work";
        }
    }
    chooseToCal() {
        let data = {
            type: 'ByVirtueEFCCalculator',
            value: 0,
        };
        this.isShowEFCResult = false;
        this.efcValue = 0;
        this.context.completeWith(data);
    }
    redirectSai() {
        let saiURL = "";
        if (this.httpSer.getEndPoint() === CONFIG.techUrl) {
            saiURL = CONFIG.efcUrl;
        }
        else {
            // saiURL = CONFIG.prodSAIUrl;
            saiURL = CONFIG.prodEfcUrl;
        }
        window.open(saiURL, "_blank");
    }
    changeAmtType(value) {
        let type = value.target.value;
        if (type == '1') {
            this.placeholder = 'Enter AGI Amount';
        }
        else {
            this.placeholder = 'Enter Income Amount';
        }
    }
    checkDisable() {
        if (this.AGImodelvalue != undefined) {
            if (this.AGImodelvalue == 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    close() {
        const val = Math.ceil(Number(this.efcValue.toString()));
        let data = {
            type: this.isShowEFCResult ? 'ByAGICalculateEFC' : 'close',
            value: val.toString(),
        };
        this.context.completeWith(data);
    }
    calCulateEFC() {
        const url = 'efcCalc/agiToEfc';
        const body = {
            agi: this.AGImodelvalue,
            stateCode: this.studentStateCode,
            taxFiler: this.taxFiler,
        };
        this.isLoading = true;
        this.httpSer.post(url, body).then((EFCValue) => {
            this.isLoading = false;
            this.efcValue = EFCValue;
            this.isShowEFCResult = true;
            this.close();
            console.log(EFCValue);
            this.cdRef.detectChanges();
        });
    }
    formatCur(val) {
        return this.codehelp.formatCurrencyRounOF(Number(val));
    }
}
ChooseToCalulateEFCDialogComponent.ɵfac = function ChooseToCalulateEFCDialogComponent_Factory(t) { return new (t || ChooseToCalulateEFCDialogComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(TuiDialogService), i0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), i0.ɵɵdirectiveInject(HttpService), i0.ɵɵdirectiveInject(CodehelpService)); };
ChooseToCalulateEFCDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChooseToCalulateEFCDialogComponent, selectors: [["lib-choose-to-calulate-efcdialog"]], features: [i0.ɵɵProvidersFeature([
            {
                provide: TUI_NUMBER_FORMAT,
                useValue: { decimalSeparator: '.', thousandSeparator: ',' },
            },
        ])], decls: 53, vars: 15, consts: [[1, "flex", "flex-row", "justify-between", "relative", "cust-outer-bottom-input"], [1, "row"], [1, "col-md-12", "text-center"], ["type", "button", "aria-label", "close", 1, "close", "pull-right", "close-profile", 2, "position", "absolute", "right", "-9px", "top", "-29px", "font-size", "25px", 3, "click"], ["aria-hidden", "true", 1, "close-b"], [1, "col-md-12", "mt-4", "mb-5", "text-center"], [1, "org-btn", 3, "click"], [1, "mr-2"], [1, "mt-3", "sailinks"], [3, "click"], [1, "col-md-12", "mb-5"], [1, "or"], [1, "col-md-8", "mb-0", 2, "margin", "0 auto"], [1, "col-md-12", "text-center", "mb-2"], [1, "col-md-12", "text-center", "fm-row", "mb-2"], [1, "col-md-12", "text-center", "fm-row"], [1, "col-md-5", "text-right"], ["type", "radio", "name", "filer", "value", "Yes", 1, "tax-filter-input", 3, "checked", "change"], [1, "tax-filer"], [1, "col-md-5", "text-center"], ["type", "radio", "name", "filer", "value", "No", 1, "tax-filter-input", 3, "checked", "change"], [1, "col-md-10", "text-center", "fm-row", 2, "margin", "0 auto"], [1, "AGI-Section-efc"], [1, "col-md-12", "st-grant"], [1, "prefix"], [1, "input-section"], [1, "currency-input", "col-row-in", 3, "prefix", "tuiTextfieldLabelOutside", "pseudoHovered", "max", "pseudoFocused", "ngModel", "ngModelChange"], [1, "col-md-12", "mb-3"], [3, "inheritColor", "showLoader", "overlay"], ["class", "row", 4, "ngIf"], [1, "text-center", "col-md-12", "btn-AGI-Section"], [1, "btn", "page-btn", "mx-1", "btn-AGI-EFC", 3, "disabled", "ngClass", "click"], [1, "col-md-12", "AGI-EFC-Result-Section"]], template: function ChooseToCalulateEFCDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h2");
        i0.ɵɵtext(4, "Calculate your Student Aid Index ");
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function ChooseToCalulateEFCDialogComponent_Template_button_click_5_listener() { return ctx.close(); });
        i0.ɵɵelementStart(6, "span", 4);
        i0.ɵɵtext(7, "\u00D7");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "button", 6);
        i0.ɵɵlistener("click", function ChooseToCalulateEFCDialogComponent_Template_button_click_9_listener() { return ctx.chooseToCal(); });
        i0.ɵɵelement(10, "span", 7);
        i0.ɵɵtext(11, "Virtue SAI Calculator ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 8);
        i0.ɵɵelementStart(13, "a", 9);
        i0.ɵɵlistener("click", function ChooseToCalulateEFCDialogComponent_Template_a_click_13_listener() { return ctx.redirectSai(); });
        i0.ɵɵtext(14, "EFC Calculator(Legacy)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵelementStart(17, "span");
        i0.ɵɵtext(18, "or");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 12);
        i0.ɵɵelementStart(20, "div", 1);
        i0.ɵɵelementStart(21, "div", 13);
        i0.ɵɵelementStart(22, "h3");
        i0.ɵɵtext(23, "Quick Estimate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 14);
        i0.ɵɵelementStart(25, "div", 1);
        i0.ɵɵelementStart(26, "div", 15);
        i0.ɵɵtext(27, "Did you or your family file taxes in 2022?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 14);
        i0.ɵɵelementStart(29, "div", 1);
        i0.ɵɵelementStart(30, "div", 16);
        i0.ɵɵelementStart(31, "input", 17);
        i0.ɵɵlistener("change", function ChooseToCalulateEFCDialogComponent_Template_input_change_31_listener() { return ctx.changeTaxFiler(true); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "label", 18);
        i0.ɵɵtext(33, "Yes");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 19);
        i0.ɵɵelementStart(35, "input", 20);
        i0.ɵɵlistener("change", function ChooseToCalulateEFCDialogComponent_Template_input_change_35_listener() { return ctx.changeTaxFiler(false); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "label", 18);
        i0.ɵɵtext(37, "No");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 21);
        i0.ɵɵelementStart(39, "div", 22);
        i0.ɵɵelementStart(40, "div", 23);
        i0.ɵɵelementStart(41, "span", 24);
        i0.ɵɵtext(42, "$");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "div", 25);
        i0.ɵɵelementStart(44, "tui-input-number", 26);
        i0.ɵɵlistener("ngModelChange", function ChooseToCalulateEFCDialogComponent_Template_tui_input_number_ngModelChange_44_listener($event) { return ctx.AGImodelvalue = $event; })("ngModelChange", function ChooseToCalulateEFCDialogComponent_Template_tui_input_number_ngModelChange_44_listener($event) { return ctx.changeAGI($event); });
        i0.ɵɵtext(45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 27);
        i0.ɵɵelementStart(47, "tui-loader", 28);
        i0.ɵɵtemplate(48, ChooseToCalulateEFCDialogComponent_div_48_Template, 6, 1, "div", 29);
        i0.ɵɵelementStart(49, "div", 1);
        i0.ɵɵelementStart(50, "div", 30);
        i0.ɵɵelementStart(51, "button", 31);
        i0.ɵɵlistener("click", function ChooseToCalulateEFCDialogComponent_Template_button_click_51_listener() { return ctx.calCulateEFC(); });
        i0.ɵɵtext(52, " Calculate Quick SAI ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(31);
        i0.ɵɵproperty("checked", ctx.taxFiler);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("checked", !ctx.taxFiler);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("prefix", "")("tuiTextfieldLabelOutside", ctx.labelOutside)("pseudoHovered", !ctx.labelOutside)("max", 999999999999999)("pseudoFocused", !ctx.labelOutside)("ngModel", ctx.AGImodelvalue);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.placeholder, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("inheritColor", true)("showLoader", ctx.isLoading)("overlay", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isShowEFCResult);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.checkDisable())("ngClass", ctx.checkDisable() ? "disabled" : "");
    } }, directives: [i5.TuiInputNumberComponent, i5.TuiInputNumberDirective, i4.TuiTextfieldLabelOutsideDirective, i7.NgControlStatus, i7.NgModel, i4.TuiLoaderComponent, i4$1.NgIf, i4$1.NgClass], styles: ["h1[_ngcontent-%COMP%]{font-size:24px}.org-btn[_ngcontent-%COMP%]{background-color:#fff;color:#f26722;font-size:20px;padding:8px 20px;border-radius:30px;border:2px #f26722 solid}.or[_ngcontent-%COMP%]{width:100%;height:1px;background-color:#ddd;position:relative}.or[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{background-color:#ddd;border-radius:50%;width:30px;height:30px;color:#666;position:absolute;left:48%;line-height:28px;text-align:center;top:-14px}h2[_ngcontent-%COMP%]{font-size:24px;color:#333}h3[_ngcontent-%COMP%]{font-size:22px;color:#f26722;font-weight:500}.close-b[_ngcontent-%COMP%]{font-size:36px;font-weight:500}.tax-filter-input[_ngcontent-%COMP%]{width:15px;height:auto!important}.tax-filer[_ngcontent-%COMP%]{display:inline-block;margin-left:8px;margin-top:10px}  tui-dialog .t-close{display:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChooseToCalulateEFCDialogComponent, [{
        type: Component,
        args: [{
                selector: 'lib-choose-to-calulate-efcdialog',
                templateUrl: './choose-to-calulate-efcdialog.component.html',
                styleUrls: ['./choose-to-calulate-efcdialog.component.css'],
                providers: [
                    {
                        provide: TUI_NUMBER_FORMAT,
                        useValue: { decimalSeparator: '.', thousandSeparator: ',' },
                    },
                ],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i4.TuiDialogService, decorators: [{
                type: Inject,
                args: [TuiDialogService]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: HttpService }, { type: CodehelpService }]; }, null); })();

class FormatLabelPipe {
    transform(value, ...args) {
        if (value != null) {
            if (value.includes('{') && value.includes('}')) {
                const endStaticString = value.substring(value.indexOf('}') + 1, value.length);
                const startStaticString = value.substring(0, value.indexOf('{'));
                const strToReplace = value.substring(value.indexOf('{') + 1, value.indexOf('}'));
                const startingSubString = strToReplace.split('@')[0];
                let splitstr = startingSubString.split('_')[1];
                if (splitstr === 'value') {
                    splitstr = strToReplace.split('@')[1];
                }
                return `${startStaticString}${splitstr}${endStaticString}`;
            }
            else {
                return value;
            }
        }
        else {
            return value;
        }
    }
}
FormatLabelPipe.ɵfac = function FormatLabelPipe_Factory(t) { return new (t || FormatLabelPipe)(); };
FormatLabelPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "formatLabel", type: FormatLabelPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatLabelPipe, [{
        type: Pipe,
        args: [{
                name: 'formatLabel'
            }]
    }], null, null); })();

class FormatSublinePipe {
    transform(value, ...args) {
        const splitVal = value.split('_');
        value = '';
        for (let i = 0; i < splitVal.length; i++) {
            value = value + splitVal[i];
        }
        // value = splitVal.toString();
        return value;
    }
}
FormatSublinePipe.ɵfac = function FormatSublinePipe_Factory(t) { return new (t || FormatSublinePipe)(); };
FormatSublinePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "formatSubline", type: FormatSublinePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatSublinePipe, [{
        type: Pipe,
        args: [{
                name: 'formatSubline'
            }]
    }], null, null); })();

function VirtueFormComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵpipe(1, "formatLabel");
    i0.ɵɵtext(2, "\n    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r1.inputWidget.display.tooltip), i0.ɵɵsanitizeHtml);
} }
function VirtueFormComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵpipe(1, "formatLabel");
    i0.ɵɵtext(2, "\n    ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r2.inputWidget.display.label), i0.ɵɵsanitizeHtml);
} }
function VirtueFormComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, "\n    ");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_1_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r22.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r22.inputWidget.moreInfo.linkLabel, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "formatLabel");
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_ng_container_1_a_4_Template, 2, 2, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r8.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r8.inputWidget.display.label.split("%s")[0]), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.inputWidget.moreInfo && ctx_r8.inputWidget.display.inputType != ctx_r8.InputType.TEXT_PLUS_LINK);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_1_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r25.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r25.inputWidget.moreInfo.linkLabel);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatLabel");
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_1_a_3_Template, 2, 2, "a", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r23.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r23.inputWidget.display.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r23.inputWidget.moreInfo);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_2_a_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r26.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r26.inputWidget.moreInfo.linkLabel);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 18);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatLabel");
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_2_a_3_Template, 2, 2, "a", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate1("for", "widget", ctx_r24.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r24.inputWidget.display.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r24.inputWidget.moreInfo && ctx_r24.inputWidget.display.inputType != ctx_r24.InputType.TEXT_PLUS_LINK);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_1_Template, 4, 5, "label", 16);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_ng_container_2_label_2_Template, 4, 5, "label", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.inputWidget.display.inputType === ctx_r9.InputType.SINGLE_SELECT_CHECKBOX);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.inputWidget.display.inputType != ctx_r9.InputType.SINGLE_SELECT_CHECKBOX);
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "tui-input-phone", 24);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template_tui_input_phone_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(4); return ctx_r33.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template_tui_input_phone_keyup_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(4); return ctx_r35.modelvalue = ctx_r35.replaceChar(ctx_r35.modelvalue, ctx_r35.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template_tui_input_phone_keydown_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r36 = i0.ɵɵnextContext(4); return ctx_r36.modelvalue = ctx_r36.replaceChar(ctx_r36.modelvalue, ctx_r36.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template_tui_input_phone_blur_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r37 = i0.ɵɵnextContext(4); return ctx_r37.checkRequired(ctx_r37.modelvalue); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r27.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r27.templateRef)("ngClass", ctx_r27.getClassinputFiled())("ngModel", ctx_r27.modelvalue)("readOnly", ctx_r27.disabled)("countryCode", "")("tuiTextfieldLabelOutside", ctx_r27.labelOutside)("phoneMaskAfterCountryCode", "###-###-####");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.inputWidget.display.placeHolder, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.inputWidget.display.suffixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_4_div_2_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "input", 26);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(4); return ctx_r40.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template_input_keyup_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(4); return ctx_r42.modelvalue = ctx_r42.replaceChar(ctx_r42.modelvalue, ctx_r42.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template_input_keydown_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(4); return ctx_r43.modelvalue = ctx_r43.replaceChar(ctx_r43.modelvalue, ctx_r43.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template_input_blur_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(4); return ctx_r44.checkRequired(ctx_r44.modelvalue); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_4_div_2_span_3_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r28.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r28.templateRef)("name", ctx_r28.inputWidget.display.label)("ngClass", ctx_r28.getClassinputFiled())("ngModel", ctx_r28.modelvalue)("placeholder", ctx_r28.inputWidget.display.placeHolder)("disabled", ctx_r28.disabled)("value", ctx_r28.inputWidget.defaultValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r29.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r32.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_4_div_1_Template, 3, 10, "div", 3);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_4_div_2_Template, 4, 11, "div", 3);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_4_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_4_span_5_Template, 2, 0, "span", 22);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_4_span_6_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_4_span_7_Template, 3, 3, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.inputWidget.fieldNo == 5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.inputWidget.fieldNo != 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r10.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.inputWidget.required && !ctx_r10.errorvalue && ctx_r10.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.errorvalue && ctx_r10.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r52.inputWidget.display.suffixText);
} }
const _c0 = function (a0) { return { "cursor-not-allowed disabled-calculate didabled-calc-link": a0 }; };
function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_a_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "a", 41);
    i0.ɵɵtext(1, "Calculate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r53.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl)("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r53.validField == "valid"));
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_5_div_1_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "tui-input-number", 36);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_tui_input_number_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(4); return ctx_r54.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_tui_input_number_keyup_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(4); return ctx_r56.modelvalue = ctx_r56.replaceChar(ctx_r56.modelvalue, ctx_r56.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_tui_input_number_keydown_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r57 = i0.ɵɵnextContext(4); return ctx_r57.modelvalue = ctx_r57.replaceChar(ctx_r57.modelvalue, ctx_r57.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_tui_input_number_blur_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r58 = i0.ɵɵnextContext(4); return ctx_r58.checkRequired(ctx_r58.modelvalue); })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_tui_input_number_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r59 = i0.ɵɵnextContext(4); return ctx_r59.modelvalue = $event; });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_5_div_1_span_4_Template, 2, 1, "span", 27);
    i0.ɵɵelementStart(5, "span", 37);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r55); const ctx_r60 = i0.ɵɵnextContext(4); return ctx_r60.inInputCleared(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 38);
    i0.ɵɵelement(7, "path", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_5_div_1_a_8_Template, 2, 4, "a", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngClass", ctx_r45.showError && ctx_r45.validField == "inValid" ? "border-red-500 border error-rd" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r45.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r45.templateRef)("ngClass", ctx_r45.getClassinputFiled())("ngModel", ctx_r45.modelvalue)("readOnly", ctx_r45.disabled)("prefix", "")("tuiTextfieldLabelOutside", ctx_r45.labelOutside)("pseudoHovered", !ctx_r45.labelOutside)("max", 999999999999999)("pseudoFocused", !ctx_r45.labelOutside)("ngModel", ctx_r45.modelvalue);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.inputWidget.display.placeHolder, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.inputWidget.display.suffixText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r45.inputWidget.moreInfo);
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r61.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r62.inputWidget.display.suffixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_a_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "a", 44);
    i0.ɵɵtext(1, "Calculate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("href", ctx_r63.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl);
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_5_div_2_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "input", 42);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return ctx_r64.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template_input_keyup_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(4); return ctx_r66.modelvalue = ctx_r66.replaceChar(ctx_r66.modelvalue, ctx_r66.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template_input_keydown_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r67 = i0.ɵɵnextContext(4); return ctx_r67.modelvalue = ctx_r67.replaceChar(ctx_r67.modelvalue, ctx_r67.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template_input_blur_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r68 = i0.ɵɵnextContext(4); return ctx_r68.checkRequired(ctx_r68.modelvalue); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_5_div_2_span_3_Template, 2, 1, "span", 27);
    i0.ɵɵelementStart(4, "span", 37);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r65); const ctx_r69 = i0.ɵɵnextContext(4); return ctx_r69.inInputCleared(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 38);
    i0.ɵɵelement(6, "path", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_5_div_2_a_7_Template, 2, 1, "a", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngClass", ctx_r46.showError && ctx_r46.validField == "inValid" ? "border-red-500 border error-rd" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r46.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r46.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r46.templateRef)("name", ctx_r46.inputWidget.display.label)("ngClass", ctx_r46.getClassinputFiled())("ngModel", ctx_r46.modelvalue)("placeholder", ctx_r46.inputWidget.display.placeHolder)("disabled", ctx_r46.disabled)("value", ctx_r46.inputWidget.defaultValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r46.inputWidget.display.suffixText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r46.inputWidget.moreInfo);
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r47.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r50.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_5_div_1_Template, 9, 17, "div", 34);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_5_div_2_Template, 8, 13, "div", 34);
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_5_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_5_span_5_Template, 2, 0, "span", 22);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_5_span_6_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_5_span_7_Template, 3, 3, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.inputWidget.display.prefixText && ctx_r11.inputWidget.display.prefixText === "$");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.inputWidget.display.prefixText || ctx_r11.inputWidget.display.prefixText !== "$");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.inputWidget.required && !ctx_r11.errorvalue && ctx_r11.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r11.errorvalue && ctx_r11.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r70.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r71.inputWidget.display.suffixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r72.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r75.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_6_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "textarea", 45);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_6_Template_textarea_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(3); return ctx_r76.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_6_Template_textarea_keyup_2_listener() { i0.ɵɵrestoreView(_r77); const ctx_r78 = i0.ɵɵnextContext(3); return ctx_r78.modelvalue = ctx_r78.replaceChar(ctx_r78.modelvalue, ctx_r78.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_6_Template_textarea_keydown_2_listener() { i0.ɵɵrestoreView(_r77); const ctx_r79 = i0.ɵɵnextContext(3); return ctx_r79.modelvalue = ctx_r79.replaceChar(ctx_r79.modelvalue, ctx_r79.inputWidget); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_6_span_3_Template, 2, 1, "span", 27);
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_6_span_5_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_6_span_6_Template, 2, 0, "span", 46);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_6_span_7_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_6_span_8_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r12.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r12.templateRef)("name", ctx_r12.inputWidget.display.label)("ngModel", ctx_r12.modelvalue)("placeholder", ctx_r12.inputWidget.display.placeHolder)("disabled", ctx_r12.disabled)("value", ctx_r12.inputWidget.defaultValue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.inputWidget.display.suffixText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.inputWidget.required && !ctx_r12.errorvalue && ctx_r12.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.errorvalue && ctx_r12.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r87.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r88.inputWidget.display.suffixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "button", 57);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r92); const ctx_r91 = i0.ɵɵnextContext(5); return ctx_r91.openChooseToCalculateModal(); });
    i0.ɵɵtext(1, "Calculate ");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "button", 58);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_9_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r94); const ctx_r93 = i0.ɵɵnextContext(5); return ctx_r93.openEfcModal(); });
    i0.ɵɵtext(1, "Calculate ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabled", ctx_r90.validField == "valid")("ngClass", ctx_r90.validField == "valid" ? "cursor-not-allowed disabled-calculate" : "");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_7_div_1_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "tui-input-number", 53);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template_tui_input_number_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(4); return ctx_r95.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template_tui_input_number_keyup_2_listener() { i0.ɵɵrestoreView(_r96); const ctx_r97 = i0.ɵɵnextContext(4); return ctx_r97.modelvalue = ctx_r97.replaceChar(ctx_r97.modelvalue, ctx_r97.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template_tui_input_number_keydown_2_listener() { i0.ɵɵrestoreView(_r96); const ctx_r98 = i0.ɵɵnextContext(4); return ctx_r98.modelvalue = ctx_r98.replaceChar(ctx_r98.modelvalue, ctx_r98.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template_tui_input_number_blur_2_listener() { i0.ɵɵrestoreView(_r96); const ctx_r99 = i0.ɵɵnextContext(4); return ctx_r99.checkRequired(ctx_r99.modelvalue); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_7_div_1_span_4_Template, 2, 1, "span", 27);
    i0.ɵɵelementStart(5, "span", 54);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r96); const ctx_r100 = i0.ɵɵnextContext(4); return ctx_r100.inInputCleared(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 38);
    i0.ɵɵelement(7, "path", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_8_Template, 2, 0, "button", 55);
    i0.ɵɵtemplate(9, VirtueFormComponent_div_9_ng_template_1_div_7_div_1_button_9_Template, 2, 2, "button", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngClass", ctx_r80.showError && ctx_r80.validField == "inValid" ? "border-red-500 border error-rd" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r80.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r80.templateRef)("ngClass", ctx_r80.getClassinputFiled())("ngModel", ctx_r80.modelvalue)("min", -1500)("readOnly", ctx_r80.disabled)("prefix", "")("tuiTextfieldLabelOutside", ctx_r80.labelOutside)("pseudoHovered", !ctx_r80.labelOutside)("max", 999999999999999)("pseudoFocused", !ctx_r80.labelOutside);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.inputWidget.display.placeHolder, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.inputWidget.display.suffixText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r80.inputWidget == null ? null : ctx_r80.inputWidget.display == null ? null : ctx_r80.inputWidget.display.inputBoxEnum) == "OPEN_DIALOG");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r80.inputWidget == null ? null : ctx_r80.inputWidget.display == null ? null : ctx_r80.inputWidget.display.inputBoxEnum) == null || (ctx_r80.inputWidget == null ? null : ctx_r80.inputWidget.display == null ? null : ctx_r80.inputWidget.display.inputBoxEnum) == "NORMAL");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r101.inputWidget.display.prefixText, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r102.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_7_div_2_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "tui-input-number", 59);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template_tui_input_number_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r104); const ctx_r103 = i0.ɵɵnextContext(4); return ctx_r103.modelvalue = $event; })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template_tui_input_number_keyup_2_listener() { i0.ɵɵrestoreView(_r104); const ctx_r105 = i0.ɵɵnextContext(4); return ctx_r105.modelvalue = ctx_r105.replaceChar(ctx_r105.modelvalue, ctx_r105.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template_tui_input_number_keydown_2_listener() { i0.ɵɵrestoreView(_r104); const ctx_r106 = i0.ɵɵnextContext(4); return ctx_r106.modelvalue = ctx_r106.replaceChar(ctx_r106.modelvalue, ctx_r106.inputWidget); })("blur", function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template_tui_input_number_blur_2_listener() { i0.ɵɵrestoreView(_r104); const ctx_r107 = i0.ɵɵnextContext(4); return ctx_r107.checkRequired(ctx_r107.modelvalue); })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template_tui_input_number_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r104); const ctx_r108 = i0.ɵɵnextContext(4); return ctx_r108.modelvalue = $event; });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_7_div_2_span_4_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r81.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r81.templateRef)("ngClass", ctx_r81.getClassinputFiled())("ngModel", ctx_r81.modelvalue)("readOnly", ctx_r81.disabled)("prefix", "")("tuiTextfieldLabelOutside", ctx_r81.labelOutside)("pseudoHovered", !ctx_r81.labelOutside)("max", 999999999999999)("pseudoFocused", !ctx_r81.labelOutside)("ngModel", ctx_r81.modelvalue);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r81.inputWidget.display.placeHolder, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r109.inputWidget.display.prefixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r110.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_7_div_3_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "input", 60);
    i0.ɵɵlistener("keyup", function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_Template_input_keyup_2_listener() { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(4); return ctx_r111.modelvalue = ctx_r111.replaceChar(ctx_r111.modelvalue, ctx_r111.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_Template_input_keydown_2_listener() { i0.ɵɵrestoreView(_r112); const ctx_r113 = i0.ɵɵnextContext(4); return ctx_r113.modelvalue = ctx_r113.replaceChar(ctx_r113.modelvalue, ctx_r113.inputWidget); })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_7_div_3_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r114 = i0.ɵɵnextContext(4); return ctx_r114.modelvalue = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_7_div_3_span_3_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r82.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r82.templateRef)("disabled", ctx_r82.disabled)("ngClass", ctx_r82.getClassinputFiled())("placeholder", ctx_r82.inputWidget.display.placeHolder)("value", ctx_r82.inputWidget.defaultValue)("maxlength", ctx_r82.maxLength)("ngModel", ctx_r82.modelvalue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r83.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 61);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r86.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_7_div_1_Template, 10, 18, "div", 50);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_7_div_2_Template, 5, 15, "div", 3);
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_7_div_3_Template, 4, 11, "div", 3);
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_7_span_5_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_7_span_6_Template, 2, 0, "span", 51);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_7_span_7_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_7_span_8_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.inputWidget.display.prefixText && ctx_r13.inputWidget.display.prefixText === "$" && ctx_r13.inputWidget.fieldNo === 40);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.inputWidget.display.prefixText && ctx_r13.inputWidget.display.prefixText === "$" && ctx_r13.inputWidget.fieldNo !== 40);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.inputWidget.display.prefixText || ctx_r13.inputWidget.display.prefixText !== "$");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.inputWidget.required && !ctx_r13.errorvalue && ctx_r13.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.errorvalue && ctx_r13.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 67);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r115 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r115.inputWidget.display.prefixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_option_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 68);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r122 = ctx.$implicit;
    i0.ɵɵproperty("value", opt_r122.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", opt_r122.label, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r117.inputWidget.display.suffixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r118 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r118.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r121 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r121.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r124 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_8_span_1_Template, 2, 1, "span", 62);
    i0.ɵɵelementStart(2, "select", 63);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_8_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r124); const ctx_r123 = i0.ɵɵnextContext(3); return ctx_r123.modelvalue = $event; })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_8_Template_select_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r124); const ctx_r125 = i0.ɵɵnextContext(3); return ctx_r125.modelChanges(ctx_r125.inputWidget, $event); });
    i0.ɵɵelementStart(3, "option", 64);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_8_option_5_Template, 2, 2, "option", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_8_span_6_Template, 2, 1, "span", 27);
    i0.ɵɵelementStart(7, "div", 20);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_8_span_8_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(9, VirtueFormComponent_div_9_ng_template_1_div_8_span_9_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(10, VirtueFormComponent_div_9_ng_template_1_div_8_span_10_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(11, VirtueFormComponent_div_9_ng_template_1_div_8_span_11_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r14.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r14.templateRef)("ngClass", ctx_r14.getClassinputFiled())("ngModel", ctx_r14.modelvalue)("disabled", ctx_r14.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.inputWidget.display.placeHolder, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r14.optionvalues);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.inputWidget.display.suffixText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r14.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.inputWidget.required && !ctx_r14.errorvalue && ctx_r14.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.errorvalue && ctx_r14.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r126 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r126.inputWidget.display.prefixText);
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_a_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 75);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r135 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate2("innerHTML", "", item_r135.value, ", ", item_r135.label, "", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", item_r135.value, ",", item_r135.label, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 75);
} if (rf & 2) {
    const item_r135 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", item_r135.value, i0.ɵɵsanitizeHtml);
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_a_0_Template, 2, 4, "a", 74);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_a_1_Template, 1, 1, "a", 74);
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r128.configId == "college_index");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r128.configId != "college_index");
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 75);
} if (rf & 2) {
    const notFound_r140 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", notFound_r140, i0.ɵɵsanitizeHtml);
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r131.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r134.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r142 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_9_span_1_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(2, "ng-autocomplete", 71);
    i0.ɵɵlistener("inputChanged", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_inputChanged_2_listener($event) { i0.ɵɵrestoreView(_r142); const ctx_r141 = i0.ɵɵnextContext(3); return ctx_r141.onChangeSearch($event); })("inputCleared", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_inputCleared_2_listener() { i0.ɵɵrestoreView(_r142); const ctx_r143 = i0.ɵɵnextContext(3); return ctx_r143.inInputCleared(); })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r142); const ctx_r144 = i0.ɵɵnextContext(3); return ctx_r144.modelvalue = $event; })("selected", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_selected_2_listener($event) { i0.ɵɵrestoreView(_r142); const ctx_r145 = i0.ɵɵnextContext(3); return ctx_r145.onSelected($event); })("inputChanged", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_inputChanged_2_listener($event) { i0.ɵɵrestoreView(_r142); const ctx_r146 = i0.ɵɵnextContext(3); return ctx_r146.getAutoSearchData($event); })("keyup", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_keyup_2_listener() { i0.ɵɵrestoreView(_r142); const ctx_r147 = i0.ɵɵnextContext(3); return ctx_r147.modelvalue = ctx_r147.replaceChar(ctx_r147.modelvalue, ctx_r147.inputWidget); })("keydown", function VirtueFormComponent_div_9_ng_template_1_div_9_Template_ng_autocomplete_keydown_2_listener() { i0.ɵɵrestoreView(_r142); const ctx_r148 = i0.ɵɵnextContext(3); return ctx_r148.modelvalue = ctx_r148.replaceChar(ctx_r148.modelvalue, ctx_r148.inputWidget); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_3_Template, 2, 2, "ng-template", null, 72, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_9_ng_template_5_Template, 1, 1, "ng-template", null, 73, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(7, "div", 20);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_9_span_8_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(9, VirtueFormComponent_div_9_ng_template_1_div_9_span_9_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(10, VirtueFormComponent_div_9_ng_template_1_div_9_span_10_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(11, VirtueFormComponent_div_9_ng_template_1_div_9_span_11_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r127 = i0.ɵɵreference(4);
    const _r129 = i0.ɵɵreference(6);
    const ctx_r15 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.inputWidget.display.prefixText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r15.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r15.templateRef)("ngModel", ctx_r15.modelvalue)("data", ctx_r15.optionvalues)("ngClass", ctx_r15.getClassinputFiled())("placeholder", ctx_r15.inputWidget.display.placeHolder)("itemTemplate", _r127)("notFoundTemplate", _r129)("disabled", ctx_r15.disabled);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r15.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.inputWidget.required && !ctx_r15.errorvalue && ctx_r15.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.errorvalue && ctx_r15.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r160 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "input", 81);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_li_2_Template_input_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r160); const item_r157 = restoredCtx.$implicit; return item_r157.checked = $event; })("change", function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_li_2_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r160); const ctx_r161 = i0.ɵɵnextContext(6); return ctx_r161.changeSelectionCheckbox(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r157 = ctx.$implicit;
    const i_r158 = ctx.index;
    const ctx_r156 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r156.inputWidget == null ? null : ctx_r156.inputWidget.fieldNo, "checkbox", i_r158, "");
    i0.ɵɵpropertyInterpolate2("name", "", ctx_r156.inputWidget == null ? null : ctx_r156.inputWidget.fieldNo, "checkbox", i_r158, "");
    i0.ɵɵproperty("ngClass", ctx_r156.getClassinputFiled())("required", i_r158 == 0 && ctx_r156.inputWidget.required)("ngModel", item_r157.checked)("disabled", ctx_r156.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r156.inputWidget == null ? null : ctx_r156.inputWidget.fieldNo, "checkbox", i_r158, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r157.label, "");
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵelementStart(1, "ul", 79);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_li_2_Template, 5, 11, "li", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r155 = i0.ɵɵnextContext(5);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r155.templateRef);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r155.optionvalues);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_div_1_Template, 3, 3, "div", 77);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r149 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r149.inputWidget == null ? null : ctx_r149.inputWidget.fieldNo);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r167 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "input", 81);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_li_2_Template_input_ngModelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r167); const item_r164 = restoredCtx.$implicit; return item_r164.checked = $event; })("change", function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_li_2_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r167); const ctx_r168 = i0.ɵɵnextContext(6); return ctx_r168.changeSelectionCheckbox(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r164 = ctx.$implicit;
    const i_r165 = ctx.index;
    const ctx_r163 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r163.inputWidget == null ? null : ctx_r163.inputWidget.fieldNo, "checkbox", i_r165, "");
    i0.ɵɵpropertyInterpolate2("name", "", ctx_r163.inputWidget == null ? null : ctx_r163.inputWidget.fieldNo, "checkbox", i_r165, "");
    i0.ɵɵproperty("ngClass", ctx_r163.getClassinputFiled())("required", i_r165 == 0 && ctx_r163.inputWidget.required)("ngModel", item_r164.checked)("disabled", ctx_r163.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("for", "", ctx_r163.inputWidget == null ? null : ctx_r163.inputWidget.fieldNo, "checkbox", i_r165, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r164.label, "");
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelementStart(1, "ul", 79);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_li_2_Template, 5, 11, "li", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r162 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r162.optionvalues);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_div_1_Template, 3, 1, "div", 83);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r150 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r150.inputWidget == null ? null : ctx_r150.inputWidget.fieldNo);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r151.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r154 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r154.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_2_Template, 2, 1, "ng-container", 3);
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_10_ng_container_3_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_10_span_5_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_10_span_6_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_10_span_7_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_10_span_8_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵattributeInterpolate1("aria-labelledby", "widget", ctx_r16.inputWidget == null ? null : ctx_r16.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.inputWidget.display.tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r16.inputWidget.display.tooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r16.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.inputWidget.required && !ctx_r16.errorvalue && ctx_r16.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r16.errorvalue && ctx_r16.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_div_2_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r178 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 89);
    i0.ɵɵelementStart(1, "button", 90);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_11_div_2_label_1_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r178); const opt_r175 = restoredCtx.$implicit; const ctx_r177 = i0.ɵɵnextContext(5); return ctx_r177.modelChanges(ctx_r177.inputWidget, opt_r175.value); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r175 = ctx.$implicit;
    const i_r176 = ctx.index;
    const ctx_r174 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate2("for", "", i_r176, "widgetradio", ctx_r174.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", i_r176, "widgetradio", ctx_r174.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngClass", ctx_r174.getClassinputFiled() || ctx_r174.selecteditem(opt_r175.value))("name", ctx_r174.inputWidget.fieldNo + "_" + i_r176);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", opt_r175.label, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 87);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_11_div_2_label_1_Template, 3, 7, "label", 88);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r169 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r169.templateRef);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r169.optionvalues);
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r170 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r170.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r173 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r173.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 85);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_11_div_2_Template, 2, 3, "div", 86);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_11_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_11_span_5_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_11_span_6_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_11_span_7_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵattributeInterpolate1("aria-labelledby", "widget", ctx_r17.inputWidget == null ? null : ctx_r17.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.inputWidget == null ? null : ctx_r17.inputWidget.fieldNo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r17.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.inputWidget.required && !ctx_r17.errorvalue && ctx_r17.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r17.errorvalue && ctx_r17.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_div_2_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r188 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 82);
    i0.ɵɵelementStart(1, "input", 93);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_12_div_2_label_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r188); const ctx_r187 = i0.ɵɵnextContext(5); return ctx_r187.modelvalue = $event; })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_12_div_2_label_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r188); const ctx_r189 = i0.ɵɵnextContext(5); return ctx_r189.modelChanges(ctx_r189.inputWidget, $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 94);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r185 = ctx.$implicit;
    const i_r186 = ctx.index;
    const ctx_r184 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate2("for", "", i_r186, "widgetradio", ctx_r184.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("id", "", i_r186, "widgetradio", ctx_r184.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngModel", ctx_r184.modelvalue)("ngClass", ctx_r184.getClassinputFiled())("name", ctx_r184.inputWidget.fieldNo + "")("value", opt_r185.value)("required", i_r186 == 0 && ctx_r184.inputWidget.required);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(opt_r185.label);
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_div_12_div_2_label_1_Template, 4, 10, "label", 92);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r179 = i0.ɵɵnextContext(4);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r179.templateRef);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r179.optionvalues);
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r180 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r180.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r183 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r183.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 91);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_div_12_div_2_Template, 2, 3, "div", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_12_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_12_span_5_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_12_span_6_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_12_span_7_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵattributeInterpolate1("aria-labelledby", "widget", ctx_r18.inputWidget == null ? null : ctx_r18.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.inputWidget == null ? null : ctx_r18.inputWidget.fieldNo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r18.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.inputWidget.required && !ctx_r18.errorvalue && ctx_r18.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r18.errorvalue && ctx_r18.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.inputWidget.display.subLine);
} }
const _c1 = function (a0) { return { "background": a0 }; };
function VirtueFormComponent_div_9_ng_template_1_div_13_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵelementStart(1, "span", 100);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r199 = ctx.option;
    const isSelected_r201 = ctx.isSelected;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c1, isSelected_r201 ? "lightgrey" : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r199, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵelementStart(1, "span", 101);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r202 = ctx.option;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", option_r202, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r194 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r194.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r197 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r197.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r205 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 95);
    i0.ɵɵelementStart(2, "ng-multiselect-dropdown", 96);
    i0.ɵɵlistener("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_13_Template_ng_multiselect_dropdown_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r205); const ctx_r204 = i0.ɵɵnextContext(3); return ctx_r204.selectedItems = $event; })("onSelect", function VirtueFormComponent_div_9_ng_template_1_div_13_Template_ng_multiselect_dropdown_onSelect_2_listener($event) { i0.ɵɵrestoreView(_r205); const ctx_r206 = i0.ɵɵnextContext(3); return ctx_r206.onMultiItemSelect($event); })("onSelectAll", function VirtueFormComponent_div_9_ng_template_1_div_13_Template_ng_multiselect_dropdown_onSelectAll_2_listener($event) { i0.ɵɵrestoreView(_r205); const ctx_r207 = i0.ɵɵnextContext(3); return ctx_r207.onMultiSelectAll($event); })("onDeSelect", function VirtueFormComponent_div_9_ng_template_1_div_13_Template_ng_multiselect_dropdown_onDeSelect_2_listener($event) { i0.ɵɵrestoreView(_r205); const ctx_r208 = i0.ɵɵnextContext(3); return ctx_r208.onMultiItemDeSelect($event); });
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_ng_template_1_div_13_ng_template_3_Template, 3, 4, "ng-template", null, 97, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_13_ng_template_5_Template, 3, 1, "ng-template", 98, 98, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 20);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_13_span_8_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(9, VirtueFormComponent_div_9_ng_template_1_div_13_span_9_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(10, VirtueFormComponent_div_9_ng_template_1_div_13_span_10_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(11, VirtueFormComponent_div_9_ng_template_1_div_13_span_11_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r19.templateRef);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placeholder", ctx_r19.inputWidget.display.placeHolder)("settings", ctx_r19.dropdownSettings)("data", ctx_r19.optionvalues)("ngModel", ctx_r19.selectedItems);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r19.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.inputWidget.required && !ctx_r19.errorvalue && ctx_r19.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r19.errorvalue && ctx_r19.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_div_14_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r209 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r209.errorvalue);
} }
function VirtueFormComponent_div_9_ng_template_1_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 69);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function VirtueFormComponent_div_9_ng_template_1_div_14_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function VirtueFormComponent_div_9_ng_template_1_div_14_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formatSubline");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r212 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r212.inputWidget.display.subLine));
} }
function VirtueFormComponent_div_9_ng_template_1_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r214 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 76);
    i0.ɵɵelementStart(2, "input", 102);
    i0.ɵɵlistener("click", function VirtueFormComponent_div_9_ng_template_1_div_14_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r214); const ctx_r213 = i0.ɵɵnextContext(3); return ctx_r213.openDateModel(ctx_r213.inputWidget.display.label); })("keyup.enter", function VirtueFormComponent_div_9_ng_template_1_div_14_Template_input_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r214); const ctx_r215 = i0.ɵɵnextContext(3); return ctx_r215.openDateModel(ctx_r215.inputWidget.display.label); })("ngModelChange", function VirtueFormComponent_div_9_ng_template_1_div_14_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r214); const ctx_r216 = i0.ɵɵnextContext(3); return ctx_r216.modelvalue = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_14_span_4_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_14_span_5_Template, 2, 0, "span", 66);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_14_span_6_Template, 1, 0, "span", 3);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_14_span_7_Template, 3, 3, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r20.inputWidget.fieldNo, "");
    i0.ɵɵproperty("ngxTippy", _r0)("tippyProps", ctx_r20.templateRef)("ngClass", ctx_r20.getClassinputFiled())("disabled", ctx_r20.disabled)("placeholder", ctx_r20.inputWidget.display.placeHolder)("value", ctx_r20.inputWidget.defaultValue)("ngModel", ctx_r20.modelvalue);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r20.errorvalue != "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.inputWidget.required && !ctx_r20.errorvalue && ctx_r20.validField == "inValid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.errorvalue && ctx_r20.validField == "valid");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.inputWidget.display.subLine);
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_15_a_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r217 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r217.inputWidget.moreInfo.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r217.inputWidget.moreInfo.linkLabel, " ");
} }
function VirtueFormComponent_div_9_ng_template_1_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "formatLabel");
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_ng_container_15_a_4_Template, 2, 2, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "widget", ctx_r21.inputWidget.fieldNo, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.inputWidget.display.label.split("%s").length > 1 ? ctx_r21.inputWidget.display.label.split("%s")[1] : i0.ɵɵpipeBind1(3, 3, ""), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.inputWidget.moreInfo);
} }
function VirtueFormComponent_div_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_ng_container_1_Template, 5, 5, "ng-container", 3);
    i0.ɵɵtemplate(2, VirtueFormComponent_div_9_ng_template_1_ng_container_2_Template, 3, 2, "ng-container", 3);
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵtemplate(4, VirtueFormComponent_div_9_ng_template_1_div_4_Template, 8, 6, "div", 10);
    i0.ɵɵtemplate(5, VirtueFormComponent_div_9_ng_template_1_div_5_Template, 8, 6, "div", 11);
    i0.ɵɵtemplate(6, VirtueFormComponent_div_9_ng_template_1_div_6_Template, 9, 14, "div", 10);
    i0.ɵɵtemplate(7, VirtueFormComponent_div_9_ng_template_1_div_7_Template, 9, 7, "div", 10);
    i0.ɵɵtemplate(8, VirtueFormComponent_div_9_ng_template_1_div_8_Template, 12, 14, "div", 10);
    i0.ɵɵtemplate(9, VirtueFormComponent_div_9_ng_template_1_div_9_Template, 12, 15, "div", 12);
    i0.ɵɵtemplate(10, VirtueFormComponent_div_9_ng_template_1_div_10_Template, 9, 7, "div", 10);
    i0.ɵɵtemplate(11, VirtueFormComponent_div_9_ng_template_1_div_11_Template, 8, 6, "div", 10);
    i0.ɵɵtemplate(12, VirtueFormComponent_div_9_ng_template_1_div_12_Template, 8, 6, "div", 10);
    i0.ɵɵtemplate(13, VirtueFormComponent_div_9_ng_template_1_div_13_Template, 12, 10, "div", 10);
    i0.ɵɵtemplate(14, VirtueFormComponent_div_9_ng_template_1_div_14_Template, 8, 12, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, VirtueFormComponent_div_9_ng_template_1_ng_container_15_Template, 5, 5, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r6.outerClassUsed ? "" : ctx_r6.inputWidget.display.className || "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.inputWidget.display.inputBoxEnum == "IN_BETWEEN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.inputWidget.display.inputBoxEnum != "IN_BETWEEN");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r6.inputWidget.display.inputType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.TEXT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.TEXT_PLUS_LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.TEXT_MULTILINE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.NUMBER);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.DROPDOWN);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.AUTO_COMPLETE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.CHECKBOX);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.SINGLE_SELECT_TAB_BUTTON);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.SINGLE_SELECT_CHECKBOX);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.MULTI_SELECT_CHECKBOX);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.InputType.DATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.inputWidget.display.inputBoxEnum == "IN_BETWEEN");
} }
function VirtueFormComponent_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 103);
    i0.ɵɵelementStart(1, "h1", 104);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.inputWidget.display.label, " ");
} }
function VirtueFormComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VirtueFormComponent_div_9_ng_template_1_Template, 16, 16, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, VirtueFormComponent_div_9_div_3_Template, 3, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.inputWidget.display.inputType === ctx_r4.InputType.HEADING)("ngIfElse", _r5);
} }
class VirtueFormComponent {
    constructor(cdr, _ngZone, dialogService, ref, injector, configSer, httpser, codehelp) {
        this.cdr = cdr;
        this._ngZone = _ngZone;
        this.dialogService = dialogService;
        this.ref = ref;
        this.injector = injector;
        this.configSer = configSer;
        this.httpser = httpser;
        this.codehelp = codehelp;
        this.addInput = new EventEmitter();
        this.removeInput = new EventEmitter();
        this.errorInput = new EventEmitter();
        this.validated = new EventEmitter();
        this.answerMap = new Map();
        this.value = '';
        this.altValue = '';
        this.widgetno = 0;
        this.disabled = false;
        this.showError = false;
        this.configId = '';
        this.outerClassUsed = false;
        //todo handle any
        this.modelvalue = '';
        this.error = false;
        this.errorvalue = '';
        this.optionvalues = [];
        this.isHidden = false;
        this.checkUncheck = false;
        this.dateformat = '';
        this.validField = 'valid';
        this.oldDefaultValue = '';
        this.labelOutside = true;
        this.maxLength = 16;
        this.oldLabel = '';
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'label',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: false,
            enableCheckAll: false,
        };
        this.selectedItems = [];
        //start date dialog box
        this.dialog = this.dialogService.open(new PolymorpheusComponent(DateDialogComponent, this.injector), {
            data: this.dateformat,
            dismissible: true,
            label: 'Heading',
        });
        this.efcDialog = this.dialogService.open(new PolymorpheusComponent(EfcDialogComponent, this.injector), {
            data: '',
            dismissible: false,
            closeable: false,
            size: 'l',
        });
        this.chooseToCalEFCDialog = this.dialogService.open(new PolymorpheusComponent(ChooseToCalulateEFCDialogComponent, this.injector), {
            data: '',
            dismissible: false,
            closeable: false,
            size: 'm',
        });
        this.templateRef = {
            arrow: true,
            placement: 'bottom-end',
            zIndex: 999,
            delay: 700,
            trigger: 'mouseenter',
            hideOnClick: true,
        };
        //end date dialog
        this.isConfigLoading = false; // to handle ngdocheckconfigload
        this.InputType = InputType;
        const brName = this.codehelp.getBrowserName();
        if (brName === 'safari') {
            this.templateRef.placement = 'auto';
        }
    }
    openEfcModal() {
        this.efcDialog.subscribe({
            next: (data) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                console.info(`Dialog emitted data = ${data}`);
                if (data != undefined && data != '') {
                    this.modelvalue = data;
                    const ansdata = {
                        fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
                        value: data,
                        type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
                        label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
                        parentwidgetno: this.widgetno,
                        altValue: this.altValue,
                        configId: this.configId,
                        conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
                        tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
                        casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
                    };
                    this.addInput.emit(ansdata);
                    this.checkValidate();
                }
            },
            complete: () => {
                console.info('Dialog closed');
            },
            error: (er) => {
                console.log('Dialog closed', er);
            },
        });
    }
    openChooseToCalculateModal() {
        let studentState = this.answerMap.get(6);
        this.chooseToCalEFCDialog = this.dialogService.open(new PolymorpheusComponent(ChooseToCalulateEFCDialogComponent, this.injector), {
            data: studentState,
            dismissible: false,
            size: 'm',
        });
        this.chooseToCalEFCDialog.subscribe({
            next: (data) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (data.type == 'ByAGICalculateEFC') {
                    console.log('ByAGICalculateEFC', data.value);
                    if (data.value != undefined) {
                        this.modelvalue = data.value;
                        const ansdata = {
                            fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
                            value: data.value,
                            type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
                            label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
                            parentwidgetno: this.widgetno,
                            altValue: this.altValue,
                            configId: this.configId,
                            conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
                            tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
                            casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
                        };
                        this.addInput.emit(ansdata);
                        this.checkValidate();
                    }
                }
                if (data.type == 'ByVirtueEFCCalculator') {
                    console.log('ByVirtueEFCCalculator', data.value);
                    this.openEfcModal();
                }
            },
            complete: () => {
                console.log('value');
            },
        });
    }
    openDateModel(head) {
        var _a, _b;
        const dataDateModel = {
            dateformat: this.dateformat,
            max: (_a = this.inputWidget.validation) === null || _a === void 0 ? void 0 : _a.maxValue,
            min: (_b = this.inputWidget.validation) === null || _b === void 0 ? void 0 : _b.minValue,
            value: '',
        };
        this.dialog = this.dialogService.open(new PolymorpheusComponent(DateDialogComponent, this.injector), {
            data: dataDateModel,
            dismissible: true,
            label: head,
        });
        this.dialog.subscribe({
            next: (data) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                let dateVal = (data === null || data === void 0 ? void 0 : data.value) || '';
                let regex = new RegExp(((_b = (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.constraints) === null || _b === void 0 ? void 0 : _b.allowInputRegex) || '', 'g');
                dateVal = dateVal.replace(regex, '');
                this.modelvalue = dateVal;
                const date = this.codehelp.dateutcIsoFormat(dateVal, ((_c = this.inputWidget.constraints) === null || _c === void 0 ? void 0 : _c.allowInputRegex) || 'YYYY-MM'); //new Date(dateVal);
                const ansdata = {
                    fieldNo: (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.fieldNo,
                    value: date,
                    type: (_f = (_e = this.inputWidget) === null || _e === void 0 ? void 0 : _e.display) === null || _f === void 0 ? void 0 : _f.inputType,
                    label: (_h = (_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.display) === null || _h === void 0 ? void 0 : _h.label,
                    parentwidgetno: this.widgetno,
                    altValue: this.altValue,
                    configId: this.configId,
                    conditionFieldNo: (_j = this.inputWidget) === null || _j === void 0 ? void 0 : _j.conditionFieldNo,
                    tags: ((_k = this.inputWidget) === null || _k === void 0 ? void 0 : _k.tags) || [],
                    casePreserve: (_l = this.inputWidget) === null || _l === void 0 ? void 0 : _l.casePreserve,
                };
                this.addInput.emit(ansdata);
                this.checkValidate();
            },
            complete: () => {
                // console.log('Dialog closed');
            },
            error: (er) => {
                console.log('Dialog closed', er);
            },
        });
    }
    // emitAnswer(fieldNo:number,value:string,type:string,label:string,parentwidgetno:number,altValue:string,configId?:string){
    //   // configId
    //   const data:Answer={
    //     fieldNo: fieldNo,
    //     value: value,
    //     type: type,
    //     label: label,
    //     parentwidgetno: parentwidgetno,
    //     altValue: altValue,
    //     configId:configId
    //     };
    //     this.addInput.emit(data);
    // }
    onSelected(val) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.modelvalue = val.value;
        if (this.inputWidget) {
            this.altValue = val.key;
            const data = {
                fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
                value: val.value,
                type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
                label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
                parentwidgetno: this.widgetno,
                altValue: val.key,
                configId: this.configId,
                conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
                tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
                casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
            };
            this.addInput.emit(data);
        }
        this.replaceChar(val.value, this.inputWidget);
    }
    ngOnChanges() {
        var _a, _b, _c, _d;
        // this.checkValidate()
        // console.log(this.inputWidget) (this.inputWidget.fieldNo === 4 || this.inputWidget.fieldNo === 5) &&
        if (((_b = (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.visibilityCondition) === null || _b === void 0 ? void 0 : _b.visibleType) === 'DISABLED' ||
            ((_d = (_c = this.inputWidget) === null || _c === void 0 ? void 0 : _c.visibilityCondition) === null || _d === void 0 ? void 0 : _d.visibleType) === 'ENABLED') {
            // console.log(this.inputWidget.required, this.errorvalue, !this.errorvalue, this.validField);
            this.checkValidate();
        }
    }
    // toCheck ngonchange not detect change
    ngDoCheck() {
        var _a;
        if ((this.inputWidget.fieldNo === 265 ||
            this.inputWidget.fieldNo === 239 ||
            this.inputWidget.fieldNo === 266 ||
            this.inputWidget.fieldNo === 240) &&
            !this.isConfigLoading) {
            this.isConfigLoading = true;
            this.configSer.getConfigData(this.configId, this.inputWidget.fieldNo, (value) => {
                if (this.optionvalues != value) {
                    this.optionvalues = value;
                    if (this.value != this.modelvalue)
                        this.setValueinField();
                    let found = false;
                    this.optionvalues.forEach((element) => {
                        if (element.value == this.modelvalue)
                            found = true;
                    });
                    if (!found) {
                        this.modelvalue = '';
                        this.replaceChar(this.modelvalue, this.inputWidget);
                        this.removeInput.emit(this.inputWidget.fieldNo);
                    }
                }
                this.isConfigLoading = false;
            });
        }
        if (this.modelvalue) {
            this.checkErrorOnChange();
        }
        // to update answermap when label update
        if (this.oldLabel != this.inputWidget.display.label &&
            this.modelvalue &&
            this.modelvalue != '') {
            this.replaceChar(this.modelvalue, this.inputWidget);
            this.oldLabel = this.inputWidget.display.label;
        }
        // if (this.inputWidget.fieldNo === 99999 && this.oldDefaultValue) { }
        // else
        if (this.inputWidget.defaultValue &&
            this.oldDefaultValue != this.inputWidget.defaultValue) {
            this.oldDefaultValue = this.inputWidget.defaultValue;
            if (Number(this.modelvalue) < Number(this.inputWidget.defaultValue) ||
                (Number(this.modelvalue) > Number(this.inputWidget.defaultValue) &&
                    ((_a = this.inputWidget.display) === null || _a === void 0 ? void 0 : _a.inputType) != InputType.DROPDOWN)) {
                this.modelvalue = this.inputWidget.defaultValue;
                this.replaceChar(this.modelvalue, this.inputWidget);
            }
            else if (this.inputWidget.display.inputType === InputType.TEXT_PLUS_LINK) {
                this.modelvalue = this.inputWidget.defaultValue;
                this.replaceChar(this.modelvalue, this.inputWidget);
            }
        }
    }
    checkErrorOnChange() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        this.error = false;
        this.errorvalue = '';
        let compareWithValue = this.modelvalue;
        if ((_a = this.inputWidget.validation) === null || _a === void 0 ? void 0 : _a.errorMessage) {
            if (((_b = this.inputWidget.display) === null || _b === void 0 ? void 0 : _b.inputType) == InputType.TEXT ||
                ((_c = this.inputWidget.display) === null || _c === void 0 ? void 0 : _c.inputType) == InputType.TEXT_MULTILINE ||
                ((_d = this.inputWidget.display) === null || _d === void 0 ? void 0 : _d.inputType) == InputType.AUTO_COMPLETE) {
                if (this.inputWidget.constraints &&
                    this.inputWidget.constraints.allowInputRegex == '[^0-9]') {
                    const reg = new RegExp(this.inputWidget.constraints.allowInputRegex);
                    // compareWithValue = compareWithValue.replace(reg,'');
                    try {
                        while (compareWithValue.toString().match(/[^$.\d]/)) {
                            compareWithValue = compareWithValue.replace(reg, '');
                        }
                    }
                    catch (er) {
                        compareWithValue = this.modelvalue.value;
                        while (compareWithValue.match(/[^$.\d]/)) {
                            compareWithValue = compareWithValue.replace(reg, '');
                        }
                    }
                }
                if (this.inputWidget.validation.minValue != 0 &&
                    compareWithValue.length < ((_e = this.inputWidget.validation) === null || _e === void 0 ? void 0 : _e.minValue)) {
                    this.emitError('add:' + ((_f = this.inputWidget.validation) === null || _f === void 0 ? void 0 : _f.errorMessage), ((_g = this.inputWidget.validation) === null || _g === void 0 ? void 0 : _g.errorMessage) || '');
                }
                if (((_h = this.inputWidget.validation) === null || _h === void 0 ? void 0 : _h.minValue) != 0 &&
                    compareWithValue.length < ((_j = this.inputWidget.validation) === null || _j === void 0 ? void 0 : _j.minValue)) {
                    this.emitError('add:' + ((_k = this.inputWidget.validation) === null || _k === void 0 ? void 0 : _k.errorMessage), ((_l = this.inputWidget.validation) === null || _l === void 0 ? void 0 : _l.errorMessage) || '');
                }
            }
            else if (this.inputWidget.display.inputType == InputType.NUMBER) {
                const regex = new RegExp(/[^0-9.]/g);
                try {
                    while (compareWithValue.toString().match(/[^$.\d]/)) {
                        compareWithValue = compareWithValue.replace(regex, '');
                    }
                }
                catch (er) {
                    compareWithValue = this.modelvalue.value;
                    while (compareWithValue.match(/[^$.\d]/)) {
                        compareWithValue = compareWithValue.replace(regex, '');
                    }
                }
                if (((_m = this.inputWidget.validation) === null || _m === void 0 ? void 0 : _m.maxValue) != 0 &&
                    Number(compareWithValue) >
                        Number((_o = this.inputWidget.validation) === null || _o === void 0 ? void 0 : _o.maxValue)) {
                    this.emitError('add:' + ((_p = this.inputWidget.validation) === null || _p === void 0 ? void 0 : _p.errorMessage), ((_q = this.inputWidget.validation) === null || _q === void 0 ? void 0 : _q.errorMessage) || '');
                }
                if (((_r = this.inputWidget.validation) === null || _r === void 0 ? void 0 : _r.minValue) != 0 &&
                    Number(compareWithValue) <
                        Number((_s = this.inputWidget.validation) === null || _s === void 0 ? void 0 : _s.minValue)) {
                    this.emitError('add:' + ((_t = this.inputWidget.validation) === null || _t === void 0 ? void 0 : _t.errorMessage), ((_u = this.inputWidget.validation) === null || _u === void 0 ? void 0 : _u.errorMessage) || '');
                }
                if (compareWithValue === '.') {
                    this.emitError('add:' + ((_v = this.inputWidget.validation) === null || _v === void 0 ? void 0 : _v.errorMessage), ((_w = this.inputWidget.validation) === null || _w === void 0 ? void 0 : _w.errorMessage) || '');
                }
            }
            if ((_x = this.inputWidget.validation) === null || _x === void 0 ? void 0 : _x.regex) {
                if (!this.testRegex((_y = this.inputWidget.validation) === null || _y === void 0 ? void 0 : _y.regex, this.modelvalue)) {
                    this.emitError('add:' + ((_z = this.inputWidget.validation) === null || _z === void 0 ? void 0 : _z.errorMessage), ((_0 = this.inputWidget.validation) === null || _0 === void 0 ? void 0 : _0.errorMessage) || '');
                }
            }
        }
        if (this.inputWidget.required == true) {
            if (this.modelvalue == '' || this.modelvalue == null) {
                this.emitError('add:' + ((_1 = this.inputWidget.validation) === null || _1 === void 0 ? void 0 : _1.errorMessage), ((_2 = this.inputWidget.validation) === null || _2 === void 0 ? void 0 : _2.errorMessage) || '');
            }
        }
        if (((_3 = this.inputWidget.validation) === null || _3 === void 0 ? void 0 : _3.maxValue) == 999999999 &&
            this.modelvalue != '0')
            this.emitError('add:' + ((_4 = this.inputWidget.validation) === null || _4 === void 0 ? void 0 : _4.errorMessage), ((_5 = this.inputWidget.validation) === null || _5 === void 0 ? void 0 : _5.errorMessage) || '');
        this.checkValidate();
    }
    getClassinputFiled() {
        let className = '';
        if (this.inputWidget.display.prefixText)
            className = 'px-4 pl-10 pr-3';
        if (this.inputWidget.display.suffixText)
            className = 'px-4 pl-10 pr-3';
        if (this.showError && this.validField == 'inValid')
            className = 'border-red-500 border-1 error-rd';
        if (this.showError &&
            this.validField == 'inValid' &&
            (this.inputWidget.display.prefixText ||
                this.inputWidget.display.suffixText))
            className = 'border-red-500 border-1 px-4 pl-10 pr-3 error-rd';
        return className;
    }
    selecteditem(value) {
        let className = '';
        if (value == this.modelvalue) {
            className = 'selected-tab';
        }
        return className;
    }
    checkValidate() {
        var _a;
        let $valid = {};
        this.validField = 'valid';
        if (this.inputWidget)
            $valid[this.inputWidget.fieldNo] = 'valid';
        if (!this.disabled) {
            if (this.error) {
                $valid[this.inputWidget.fieldNo] = 'inValid';
                this.validField = 'inValid';
            }
            else if ((_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.required) {
                if (this.modelvalue === undefined ||
                    this.modelvalue === '' ||
                    !this.modelvalue) {
                    $valid[this.inputWidget.fieldNo] = 'inValid';
                    this.validField = 'inValid';
                }
            }
        }
        if (this.disabled) {
            this.modelvalue = '';
            this.error = false;
            this.errorvalue = '';
        }
        // if (this.inputWidget.fieldNo === 4 || this.inputWidget.fieldNo === 5)
        //   console.log(this.inputWidget.required, this.errorvalue,!this.errorvalue, this.validField);
        this.validated.emit($valid);
    }
    get content() {
        return ' ';
    }
    //set prefilled value
    setValueinField() {
        var _a, _b;
        // if(this.value)
        this.oldDefaultValue = this.value;
        this.oldLabel = this.inputWidget.display.label;
        if (this.inputWidget.display.inputType === InputType.DATE && this.value) {
            if ((_a = this.inputWidget.constraints) === null || _a === void 0 ? void 0 : _a.allowInputRegex) {
                this.modelvalue = this.codehelp.formatDate(this.value, ((_b = this.inputWidget.constraints) === null || _b === void 0 ? void 0 : _b.allowInputRegex) || 'YYYY-MM');
            }
        }
        else {
            if (this.inputWidget.casePreserve == 'FALSE' &&
                this.inputWidget.fieldNo !== 4) {
                this.modelvalue = this.codehelp.transformTitle(this.value);
            }
            else
                this.modelvalue = this.value;
            // this.ref.detectChanges();
        }
        if (this.inputWidget.display.prefixText == '$') {
            if (!this.value)
                this.modelvalue = null;
        }
        if (this.modelvalue) {
            this.checkErrorOnChange();
            this.replaceChar(this.modelvalue, this.inputWidget);
        }
    }
    changeSelectionCheckbox() {
        this.fetchSelectedItems();
    }
    fetchSelectedItems() {
        const selected = this.optionvalues.filter((value, index) => {
            return value.checked;
        });
        let checkedIDs = [];
        this.optionvalues.forEach((value, index) => {
            if (value.checked) {
                checkedIDs.push(value.value);
            }
        });
        // console.log(checkedIDs)
        this.modelvalue = checkedIDs.toString();
        this.checkValidate();
        this.modelChanges(this.inputWidget, checkedIDs.toString());
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const providerID = this.codehelp.getStoreValue('providerID');
        if (((_a = this.inputWidget.constraints) === null || _a === void 0 ? void 0 : _a.size) &&
            this.inputWidget.display.inputType === InputType.NUMBER) {
            this.maxLength = (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.constraints) === null || _c === void 0 ? void 0 : _c.size;
        }
        if (this.inputWidget.fieldNo != 265 && this.inputWidget.fieldNo != 240)
            this.setValueinField();
        let data = {
            fieldNo: this.inputWidget.fieldNo,
            value: '',
            type: (_d = this.inputWidget.display) === null || _d === void 0 ? void 0 : _d.inputType,
            label: (_e = this.inputWidget.display) === null || _e === void 0 ? void 0 : _e.label,
            parentwidgetno: this.widgetno,
            altValue: this.altValue,
            configId: this.configId,
            tags: this.inputWidget.tags || [],
            casePreserve: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.casePreserve,
        };
        if (this.inputWidget && this.configId) {
            if (this.inputWidget.configId === 'high_school') {
                if (this.value)
                    data.value = this.value;
                this.getAutoSearchData(this.value);
                data.altValue = this.altValue;
                this.addInput.emit(data);
            }
            else if (this.configId == 'college_index') {
                if (this.value)
                    data.value = this.value;
                this.getAutoSearchData(this.value);
                data.altValue = this.altValue;
                this.addInput.emit(data);
            }
            else {
                if (this.inputWidget.fieldNo != 265 &&
                    this.inputWidget.fieldNo != 239 &&
                    this.inputWidget.fieldNo != 266 &&
                    this.inputWidget.fieldNo != 240)
                    this.configSer.getConfigData(this.configId, this.inputWidget.fieldNo, (value) => {
                        var _a;
                        this.optionvalues = value;
                        this.ref.markForCheck();
                        // this.modelvalue = this.modelvalue;
                        // this.ref.detectChanges();
                        //to handle selected value of checkbox
                        if (this.inputWidget.display.inputType ===
                            InputType.MULTI_SELECT_CHECKBOX &&
                            this.value) {
                            // this.selectedItems = this.selectedItems.concat(this.optionvalues.find(elem => this.value.split(',').includes(elem.value)) || []);
                            // this.selectedItems.forEach(elem =>{
                            //   // this.modelvalue
                            // })
                            // this.modelvalue = this.selectedItems;
                            this.selectedItems = [];
                            this.optionvalues.forEach((elem) => {
                                const ar = this.value.split(',');
                                if (ar.includes(elem.value)) {
                                    const data = {
                                        id: elem.id,
                                        label: elem.label,
                                    };
                                    this.selectedItems.push(data);
                                }
                            });
                        }
                        //start this to handle config condition prefillef populated on next and back
                        if (this.modelvalue &&
                            this.configId &&
                            this.inputWidget.defaultValue &&
                            this.inputWidget.configConditions.length &&
                            !this.value) {
                            const foundModal = this.optionvalues.find((element) => {
                                return element.value == this.modelvalue;
                            });
                            const foundDefault = this.optionvalues.find((element) => {
                                return element.value == this.inputWidget.defaultValue;
                            });
                            if (!foundModal &&
                                foundDefault &&
                                this.configId != 'high_school') {
                                this.modelvalue = this.inputWidget.defaultValue;
                                data.value = (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.defaultValue;
                                this.addInput.emit(data);
                            }
                            else if (!foundModal &&
                                !foundDefault &&
                                this.configId != 'high_school') {
                                this.modelvalue = '';
                                this.replaceChar(this.modelvalue, this.inputWidget);
                                this.removeInput.emit(this.inputWidget.fieldNo);
                            }
                        }
                        //end this to handle config condition prefillef populated on next and back
                    });
            }
        }
        else if (this.inputWidget &&
            ((_h = (_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.display) === null || _h === void 0 ? void 0 : _h.options) &&
            ((_k = (_j = this.inputWidget) === null || _j === void 0 ? void 0 : _j.display) === null || _k === void 0 ? void 0 : _k.options.length) &&
            !this.configId) {
            const opt = [];
            const ar = [];
            (_m = (_l = this.inputWidget) === null || _l === void 0 ? void 0 : _l.display) === null || _m === void 0 ? void 0 : _m.options.forEach((elem) => {
                var _a;
                const val = {
                    value: (elem === null || elem === void 0 ? void 0 : elem.value) || '',
                    key: (elem === null || elem === void 0 ? void 0 : elem.text) || '',
                    label: (elem === null || elem === void 0 ? void 0 : elem.text) || '',
                    checked: false,
                };
                if (this.inputWidget &&
                    this.inputWidget.defaultValue &&
                    this.modelvalue == '') {
                    this.modelvalue = this.inputWidget.defaultValue;
                    if (this.inputWidget.defaultValue.includes((elem === null || elem === void 0 ? void 0 : elem.value) || '')) {
                        val.checked = true;
                        data.value = (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.defaultValue;
                        this.addInput.emit(data);
                    }
                }
                if (this.value.includes((elem === null || elem === void 0 ? void 0 : elem.value) || '')) {
                    val.checked = true;
                    data.value = this.value;
                    this.addInput.emit(data);
                }
                ar.push(val);
            });
            this.optionvalues = ar;
        }
        if (this.inputWidget &&
            this.inputWidget.defaultValue &&
            this.modelvalue == '') {
            this.modelvalue = this.inputWidget.defaultValue;
            data.value = (_o = this.inputWidget) === null || _o === void 0 ? void 0 : _o.defaultValue;
            if (this.configId != 'high_school') {
                this.addInput.emit(data);
            }
        }
        this.checkValidate();
        if (this.inputWidget &&
            this.inputWidget.display.inputType === InputType.DATE) {
            this.dateformat = ((_q = (_p = this.inputWidget) === null || _p === void 0 ? void 0 : _p.constraints) === null || _q === void 0 ? void 0 : _q.allowInputRegex) || '';
        }
    }
    getAutoSearchData(search) {
        if (this.configId == 'high_school') {
            const url = 'fieldConfig/thirdParty?url=https://tech.virtueanalytics.com/se_mu/config/highschool?highschoolexp=' +
                search;
            this.httpser.get(url, '').then((resp) => {
                this.optionvalues = resp.data;
                // this.cdr.detectChanges();
            });
        }
        else if (this.configId == 'college_index') {
            // select?fl=name,
            let url = `https://search.virtueanalytics.com/solr/college_index/select?indent=true&q.op=OR&q=indexData:*${search}* OR indexData:${search}* OR name:${search}~5`;
            if (!search)
                url = `https://search.virtueanalytics.com/solr/college_index/select?indent=true&q.op=OR&q=indexData:*`;
            this.httpser.getCdn(url, '').then((resp) => {
                const ar = [];
                resp.response.docs.forEach((element) => {
                    let stcode = eval('(' + element.extraData + ')').stateCode;
                    const elem = {
                        value: element.name,
                        key: element.id,
                        label: stcode,
                    };
                    ar.push(elem);
                });
                this.optionvalues = ar;
            });
        }
    }
    itemHidden() {
        var _a;
        if (this.inputWidget && ((_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.hidden))
            return true;
        else
            return false;
    }
    isValidationAvailable() {
        if (typeof this.inputWidget.validation)
            return true;
        else
            return false;
    }
    replaceChar(value, data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        this.error = false;
        this.errorvalue = '';
        //to handele autocomplete TODO
        if (value && typeof value == 'object') {
            value = value.value;
        }
        if (value != null && typeof value != 'string')
            value = value.toString();
        if (value) {
            if (data.constraints && ((_a = data.constraints) === null || _a === void 0 ? void 0 : _a.valueFormatRegex)) {
                value = value.replace(/[^\d]/g, '');
            }
            if (data.display.inputType == InputType.TEXT ||
                data.display.inputType == InputType.TEXT_PLUS_LINK ||
                ((_b = data.display) === null || _b === void 0 ? void 0 : _b.inputType) == InputType.AUTO_COMPLETE) {
                if (data.constraints && data.constraints.allowInputRegex) {
                    let regex = new RegExp(data.constraints.allowInputRegex, 'g');
                    value = value.replace(regex, '');
                    if (data.constraints &&
                        data.constraints.allowInputRegex == '[^0-9]') {
                        const reg = new RegExp(data.constraints.allowInputRegex);
                        value = value.replace(reg, '');
                    }
                }
            }
            else if (data.display.inputType == InputType.NUMBER && data.fieldNo != 40) {
                const regex = new RegExp(/[^0-9.]/g);
                value = value.replace(regex, '');
                // handling more than one dot start
                const slpitval = value.split('.');
                if (slpitval.length > 2) {
                    const regForAcceptOneDot = new RegExp('[^\\d]');
                    value = value.replace(regForAcceptOneDot, '');
                }
                if (data.constraints && data.constraints.allowInputRegex == '[^0-9]') {
                    const reg = new RegExp(data.constraints.allowInputRegex);
                    value = value.replace(reg, '');
                }
                else if (data.constraints && data.constraints.allowInputRegex) {
                    value = this.replaceViaReg(value + '', data.constraints.allowInputRegex);
                }
            }
            if ((_c = data.validation) === null || _c === void 0 ? void 0 : _c.errorMessage) {
                if (((_d = data.display) === null || _d === void 0 ? void 0 : _d.inputType) == InputType.TEXT ||
                    ((_e = data.display) === null || _e === void 0 ? void 0 : _e.inputType) == InputType.TEXT_MULTILINE ||
                    ((_f = data.display) === null || _f === void 0 ? void 0 : _f.inputType) == InputType.AUTO_COMPLETE) {
                    if (((_g = data.validation) === null || _g === void 0 ? void 0 : _g.maxValue) != 0 &&
                        value.length > ((_h = data.validation) === null || _h === void 0 ? void 0 : _h.maxValue)) {
                        value = value.substring(0, (_j = data.validation) === null || _j === void 0 ? void 0 : _j.maxValue);
                    }
                    if (data.validation.minValue != 0 &&
                        value.length < ((_k = data.validation) === null || _k === void 0 ? void 0 : _k.minValue)) {
                        this.emitError('add:' + ((_l = this.inputWidget.validation) === null || _l === void 0 ? void 0 : _l.errorMessage), ((_m = this.inputWidget.validation) === null || _m === void 0 ? void 0 : _m.errorMessage) || '');
                    }
                    if (((_o = data.validation) === null || _o === void 0 ? void 0 : _o.minValue) != 0 &&
                        value.length < ((_p = data.validation) === null || _p === void 0 ? void 0 : _p.minValue)) {
                        this.emitError('add:' + ((_q = this.inputWidget.validation) === null || _q === void 0 ? void 0 : _q.errorMessage), ((_r = this.inputWidget.validation) === null || _r === void 0 ? void 0 : _r.errorMessage) || '');
                    }
                }
                else if (data.display.inputType == InputType.NUMBER) {
                    if (((_s = data.validation) === null || _s === void 0 ? void 0 : _s.maxValue) != 0 &&
                        Number(value) > Number((_t = data.validation) === null || _t === void 0 ? void 0 : _t.maxValue)) {
                        this.emitError('add:' + ((_u = this.inputWidget.validation) === null || _u === void 0 ? void 0 : _u.errorMessage), ((_v = this.inputWidget.validation) === null || _v === void 0 ? void 0 : _v.errorMessage) || '');
                    }
                    if (((_w = data.validation) === null || _w === void 0 ? void 0 : _w.minValue) != 0 &&
                        Number(value) < Number((_x = data.validation) === null || _x === void 0 ? void 0 : _x.minValue)) {
                        this.emitError('add:' + ((_y = this.inputWidget.validation) === null || _y === void 0 ? void 0 : _y.errorMessage), ((_z = this.inputWidget.validation) === null || _z === void 0 ? void 0 : _z.errorMessage) || '');
                    }
                    if (value === '.') {
                        this.emitError('add:' + ((_0 = this.inputWidget.validation) === null || _0 === void 0 ? void 0 : _0.errorMessage), ((_1 = this.inputWidget.validation) === null || _1 === void 0 ? void 0 : _1.errorMessage) || '');
                    }
                }
                if ((_2 = data.validation) === null || _2 === void 0 ? void 0 : _2.regex) {
                    if (!this.testRegex((_3 = data.validation) === null || _3 === void 0 ? void 0 : _3.regex, value)) {
                        this.emitError('add:' + ((_4 = this.inputWidget.validation) === null || _4 === void 0 ? void 0 : _4.errorMessage), ((_5 = this.inputWidget.validation) === null || _5 === void 0 ? void 0 : _5.errorMessage) || '');
                    }
                }
            }
        }
        if (data.required == true) {
            // if(value !== null)
            //   value = value+ '';
            if (value === '' || value === null) {
                this.emitError('add:' + ((_6 = this.inputWidget.validation) === null || _6 === void 0 ? void 0 : _6.errorMessage), ((_7 = this.inputWidget.validation) === null || _7 === void 0 ? void 0 : _7.errorMessage) || '');
            }
        }
        if (((_8 = data.validation) === null || _8 === void 0 ? void 0 : _8.maxValue) == 999999999) {
            this.emitError('add:' + ((_9 = this.inputWidget.validation) === null || _9 === void 0 ? void 0 : _9.errorMessage), ((_10 = this.inputWidget.validation) === null || _10 === void 0 ? void 0 : _10.errorMessage) || '');
            // value = '0';
        }
        this.modelChanges(this.inputWidget, value);
        this.checkValidate(); //to check valid page
        return value;
    }
    checkRequired(modelvalue) {
        var _a, _b, _c;
        if (this.modelvalue)
            this.modelvalue = this.modelvalue.trim();
        if ((_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.required) {
            if (this.modelvalue === undefined ||
                this.modelvalue === '' ||
                !this.modelvalue) {
                this.emitError('add:' + ((_b = this.inputWidget.validation) === null || _b === void 0 ? void 0 : _b.errorMessage), ((_c = this.inputWidget.validation) === null || _c === void 0 ? void 0 : _c.errorMessage) || '');
            }
        }
        this.checkValidate();
    }
    getAltvalue() {
        var _a;
        const _this = this;
        const val = this.optionvalues.find((element) => {
            return element.value == _this.modelvalue;
        });
        let altval = '';
        if (_this.configId === 'high_school') {
            if ((val === null || val === void 0 ? void 0 : val.value) == ((_a = _this.modelvalue) === null || _a === void 0 ? void 0 : _a.value)) {
                altval = (val === null || val === void 0 ? void 0 : val.key) || '';
            }
        }
        else {
            if ((val === null || val === void 0 ? void 0 : val.value) == _this.modelvalue) {
                altval = (val === null || val === void 0 ? void 0 : val.altValue) || '';
            }
        }
        return altval;
    }
    modelChanges(element, currentvalue) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        // currentvalue = currentvalue + '';
        if (currentvalue != null && typeof currentvalue != 'string')
            currentvalue = currentvalue.toString();
        if ((currentvalue && currentvalue + '' != '') || currentvalue === 0) {
            let data = {
                fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
                value: '',
                type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
                label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
                parentwidgetno: this.widgetno,
                altValue: this.altValue,
                configId: this.configId,
                conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
                tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
                casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
            };
            if (this.configId && this.configId != 'high_school') {
                const altValue = this.getAltvalue();
                this.altValue = altValue;
                data.altValue = altValue;
            }
            if (this.inputWidget.display.inputType == InputType.TEXT ||
                this.inputWidget.display.inputType == InputType.TEXT_MULTILINE) {
                if (this.inputWidget.constraints &&
                    this.inputWidget.constraints.allowInputRegex) {
                    let regex = new RegExp(this.inputWidget.constraints.allowInputRegex, 'g');
                    currentvalue = currentvalue.toString().replace(regex, '');
                }
            }
            else if (this.inputWidget.display.inputType == InputType.NUMBER && this.inputWidget.fieldNo != 40) {
                const regex = new RegExp(/[^0-9.]/g);
                currentvalue = currentvalue.toString().replace(regex, '');
            }
            if (this.inputWidget.display.inputType == InputType.SINGLE_SELECT_CHECKBOX) {
                data.value = currentvalue.toString();
            }
            if (this.inputWidget.display.inputType == InputType.MULTI_SELECT_TAB_BUTTON) {
                data.value = currentvalue.toString();
                this.modelvalue = data.value;
            }
            if (this.inputWidget.display.inputType == InputType.SINGLE_SELECT_TAB_BUTTON) {
                data.value = currentvalue.toString();
                this.modelvalue = data.value;
            }
            if (((_j = this.inputWidget) === null || _j === void 0 ? void 0 : _j.display.inputType) == InputType.TEXT ||
                this.inputWidget.display.inputType == InputType.TEXT_MULTILINE ||
                this.inputWidget.display.inputType == InputType.TEXT_PLUS_LINK) {
                data.value = currentvalue.toString();
            }
            if (((_k = this.inputWidget) === null || _k === void 0 ? void 0 : _k.display.inputType) == InputType.NUMBER) {
                data.value = currentvalue.toString();
            }
            if (((_l = this.inputWidget) === null || _l === void 0 ? void 0 : _l.display.inputType) == InputType.DROPDOWN) {
                data.value = currentvalue.toString();
            }
            if (((_m = this.inputWidget) === null || _m === void 0 ? void 0 : _m.display.inputType) == InputType.CHECKBOX) {
                data.value = currentvalue.toString();
            }
            if (((_o = this.inputWidget) === null || _o === void 0 ? void 0 : _o.display.inputType) == InputType.AUTO_COMPLETE) {
                if (this.configId === 'high_school') {
                    data.altValue = this.getAltvalue();
                }
            }
            this.checkValidate();
            // if (this.inputWidget?.display.inputType != 'AUTO_COMPLETE')
            this.addInput.emit(data);
        }
        else {
            this.removeInput.emit(this.inputWidget.fieldNo);
        }
    }
    emitError(valuetoemit, msg) {
        this.errorvalue = msg; // show error on input field
        this.error = true;
        // this.cdr.detectChanges();
        this.errorInput.emit(valuetoemit);
    }
    testRegex(regexString, inputString) {
        let reg = new RegExp(regexString);
        return reg.test(inputString);
    }
    replaceViaReg(str, regStr) {
        let reg = new RegExp(regStr);
        return str.replace(reg, '$1');
    }
    inInputCleared() {
        if (this.inputWidget.display.prefixText === '$') {
            this.modelvalue = undefined;
        }
        else {
            this.modelvalue = '';
        }
        this.replaceChar(this.modelvalue, this.inputWidget);
        this.removeInput.emit(this.inputWidget.fieldNo);
        this.checkValidate();
    }
    onChangeSearch(val) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (((_a = this.inputWidget.constraints) === null || _a === void 0 ? void 0 : _a.size) &&
            this.modelvalue.length > ((_b = this.inputWidget.constraints) === null || _b === void 0 ? void 0 : _b.size)) {
            this.modelvalue = this.modelvalue.substring(0, (_c = this.inputWidget.constraints) === null || _c === void 0 ? void 0 : _c.size);
        }
        if (this.inputWidget) {
            if (this.inputWidget.fieldNo != 239) {
                if (this.modelvalue != '') {
                    this.altValue = (val === null || val === void 0 ? void 0 : val.key) || '';
                    const data = {
                        fieldNo: (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.fieldNo,
                        value: this.modelvalue,
                        type: (_f = (_e = this.inputWidget) === null || _e === void 0 ? void 0 : _e.display) === null || _f === void 0 ? void 0 : _f.inputType,
                        label: (_h = (_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.display) === null || _h === void 0 ? void 0 : _h.label,
                        parentwidgetno: this.widgetno,
                        altValue: val.key,
                        configId: this.configId,
                        conditionFieldNo: (_j = this.inputWidget) === null || _j === void 0 ? void 0 : _j.conditionFieldNo,
                        tags: ((_k = this.inputWidget) === null || _k === void 0 ? void 0 : _k.tags) || [],
                        casePreserve: (_l = this.inputWidget) === null || _l === void 0 ? void 0 : _l.casePreserve,
                    };
                    this.addInput.emit(data);
                }
                else {
                    this.removeInput.emit(this.inputWidget.fieldNo);
                }
            }
            else {
                //
                if (this.modelvalue.length > 4) {
                    let found = false;
                    this.optionvalues.forEach((element) => {
                        if (element.value == this.modelvalue)
                            found = true;
                    });
                    if (!found) {
                        this.modelvalue = '';
                    }
                }
            }
        }
    }
    onMultiItemDeSelect(ev) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let value = '';
        this.selectedItems.forEach((elem) => {
            const dataOp = this.optionvalues.find((opt) => {
                return elem.id === opt.id;
            });
            if (dataOp) {
                if (value) {
                    value = `${value},${dataOp === null || dataOp === void 0 ? void 0 : dataOp.value}`;
                }
                else {
                    value = dataOp === null || dataOp === void 0 ? void 0 : dataOp.value;
                }
            }
        });
        this.modelvalue = value;
        let data = {
            fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
            value: value,
            type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
            label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
            parentwidgetno: this.widgetno,
            altValue: '',
            configId: this.configId,
            conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
            tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
            casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
        };
        this.addInput.emit(data);
        this.checkValidate();
        this.modelChanges(this.inputWidget, value);
    }
    onMultiItemSelect(ev) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let value = '';
        // selectedItems
        this.selectedItems.forEach((elem) => {
            const dataOp = this.optionvalues.find((opt) => {
                return elem.id === opt.id;
            });
            if (dataOp) {
                if (value) {
                    value = `${value},${dataOp === null || dataOp === void 0 ? void 0 : dataOp.value}`;
                }
                else {
                    value = dataOp === null || dataOp === void 0 ? void 0 : dataOp.value;
                }
            }
        });
        this.modelvalue = value;
        let data = {
            fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
            value: value,
            type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
            label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
            parentwidgetno: this.widgetno,
            altValue: '',
            configId: this.configId,
            conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
            tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
            casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
        };
        this.addInput.emit(data);
        this.checkValidate();
        this.modelChanges(this.inputWidget, value);
    }
    onMultiSelectAll(ev) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let value = '';
        ev.forEach((elem) => {
            const dataOp = this.optionvalues.find((opt) => {
                return elem.id === opt.id;
            });
            if (dataOp) {
                if (value) {
                    value = `${value},${dataOp === null || dataOp === void 0 ? void 0 : dataOp.value}`;
                }
                else {
                    value = dataOp === null || dataOp === void 0 ? void 0 : dataOp.value;
                }
            }
        });
        this.modelvalue = value;
        let data = {
            fieldNo: (_a = this.inputWidget) === null || _a === void 0 ? void 0 : _a.fieldNo,
            value: value,
            type: (_c = (_b = this.inputWidget) === null || _b === void 0 ? void 0 : _b.display) === null || _c === void 0 ? void 0 : _c.inputType,
            label: (_e = (_d = this.inputWidget) === null || _d === void 0 ? void 0 : _d.display) === null || _e === void 0 ? void 0 : _e.label,
            parentwidgetno: this.widgetno,
            altValue: '',
            configId: this.configId,
            conditionFieldNo: (_f = this.inputWidget) === null || _f === void 0 ? void 0 : _f.conditionFieldNo,
            tags: ((_g = this.inputWidget) === null || _g === void 0 ? void 0 : _g.tags) || [],
            casePreserve: (_h = this.inputWidget) === null || _h === void 0 ? void 0 : _h.casePreserve,
        };
        this.addInput.emit(data);
        this.checkValidate();
        this.modelChanges(this.inputWidget, value);
    }
}
VirtueFormComponent.ɵfac = function VirtueFormComponent_Factory(t) { return new (t || VirtueFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(TuiDialogService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(Injector), i0.ɵɵdirectiveInject(ConfigMapService), i0.ɵɵdirectiveInject(HttpService), i0.ɵɵdirectiveInject(CodehelpService)); };
VirtueFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VirtueFormComponent, selectors: [["lib-virtue-form"]], inputs: { inputWidget: "inputWidget", answerMap: "answerMap", value: "value", altValue: "altValue", widgetno: "widgetno", disabled: "disabled", showError: "showError", configId: "configId", outerClassUsed: "outerClassUsed" }, outputs: { addInput: "addInput", removeInput: "removeInput", errorInput: "errorInput", validated: "validated" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: TUI_NUMBER_FORMAT,
                useValue: { decimalSeparator: '.', thousandSeparator: ',' },
            },
        ]), i0.ɵɵNgOnChangesFeature], decls: 10, vars: 4, consts: [["htmlTemplate", ""], ["class", "t-template", 3, "innerHTML", 4, "ngIf"], ["class", "t-template", 4, "ngIf"], [4, "ngIf"], [1, "t-template", 3, "innerHTML"], [1, "t-template"], ["inputdata", ""], ["class", "row", 4, "ngIf", "ngIfElse"], [1, "virtue-lib-outer", 3, "ngClass"], [3, "ngSwitch"], ["class", "", 4, "ngSwitchCase"], ["class", "cust-link", 4, "ngSwitchCase"], ["class", "relative ", 4, "ngSwitchCase"], [1, "block", "text-gray-600", "text-base", "mb-2", "cust-label", 3, "id"], ["class", "text-right text-sm", "target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 1, "text-right", "text-sm", 3, "href"], ["class", "block text-gray-600 text-base mb-2 cust-label", 3, "id", 4, "ngIf"], ["class", "block text-gray-600 text-base mb-2 cust-label", 3, "for", 4, "ngIf"], [1, "block", "text-gray-600", "text-base", "mb-2", "cust-label", 3, "for"], [1, ""], [1, "flex", "flex-row", "justify-between", "relative", "cust-outer-bottom-input"], ["class", "text-red-500 text-xs italic error-message left-0 animate__animated animate__fadeInDown absolute", 4, "ngIf"], ["class", "text-xs required text-red-400 italic animate__animated animate__fadeInDown absolute cust-required", 4, "ngIf"], ["class", "text-sm text-blue-600 italic absolute right-0 cust-subline", 4, "ngIf"], ["tippyClassName", "popover-content", "autocomplete", "field_value_none", 1, "mobile-place", "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "cust-phone", "text-gray-700", "leading-tight", 3, "ngxTippy", "tippyProps", "id", "ngClass", "ngModel", "readOnly", "countryCode", "tuiTextfieldLabelOutside", "phoneMaskAfterCountryCode", "ngModelChange", "keyup", "keydown", "blur"], ["class", "z-10 leading-snug font-normal absolute text-center py-2 text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 ", 4, "ngIf"], ["tippyClassName", "popover-content", "type", "text", "autocomplete", "field_value_none", "autocomplete", "off", 1, "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "py-2", "px-3", "text-gray-700", "leading-tight", "cust-text", 3, "ngxTippy", "tippyProps", "id", "name", "ngClass", "ngModel", "placeholder", "disabled", "value", "ngModelChange", "keyup", "keydown", "blur"], ["class", "z-10 right-0 leading-snug font-normal absolute py-2 text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8", 4, "ngIf"], [1, "z-10", "leading-snug", "font-normal", "absolute", "text-center", "py-2", "text-blueGray-300", "absolute", "bg-transparent", "rounded", "text-base", "items-center", "justify-center", "w-8"], [1, "z-10", "right-0", "leading-snug", "font-normal", "absolute", "py-2", "text-center", "text-blueGray-300", "absolute", "bg-transparent", "rounded", "text-base", "items-center", "justify-center", "w-8"], [1, "text-red-500", "text-xs", "italic", "error-message", "left-0", "animate__animated", "animate__fadeInDown", "absolute"], [1, "text-xs", "required", "text-red-400", "italic", "animate__animated", "animate__fadeInDown", "absolute", "cust-required"], [1, "text-sm", "text-blue-600", "italic", "absolute", "right-0", "cust-subline"], [1, "cust-link"], ["class", " cust-div-link", 3, "ngClass", 4, "ngIf"], [1, "cust-div-link", 3, "ngClass"], ["tippyClassName", "popover-content", "autocomplete", "field_value_none", 1, "cust-link-currency", "bg-white", "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "text-gray-700", "leading-tight", 3, "ngxTippy", "tippyProps", "id", "ngClass", "ngModel", "readOnly", "prefix", "tuiTextfieldLabelOutside", "pseudoHovered", "max", "pseudoFocused", "ngModelChange", "keyup", "keydown", "blur"], [1, "clear-icon", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "fill", "none", "viewBox", "0 0 24 24", "stroke-width", "1.5", "stroke", "currentColor", 1, "w-6", "h-6"], ["stroke-linecap", "round", "stroke-linejoin", "round", "d", "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"], ["class", "btn btn-blue mb cust-link-btn", "target", "_blank", 3, "href", "ngClass", 4, "ngIf"], ["target", "_blank", 1, "btn", "btn-blue", "mb", "cust-link-btn", 3, "href", "ngClass"], ["tippyClassName", "popover-content", "type", "text", "autocomplete", "field_value_none", "autocomplete", "off", 1, "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "py-2", "px-3", "text-gray-700", "leading-tight", "cust-link", 3, "ngxTippy", "tippyProps", "id", "name", "ngClass", "ngModel", "placeholder", "disabled", "value", "ngModelChange", "keyup", "keydown", "blur"], ["class", "btn btn-blue mb cust-link-btn", "target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 1, "btn", "btn-blue", "mb", "cust-link-btn", 3, "href"], ["tippyClassName", "popover-content", "type", "text", "autocomplete", "field_value_none", "autocomplete", "off", 1, "appearance-none", "border", "border-gray-200", "rounded", "w-full", "py-2", "px-3", "text-gray-700", "mb-2", "leading-tight", "cust-textarea", 3, "ngxTippy", "tippyProps", "id", "name", "ngModel", "placeholder", "disabled", "value", "ngModelChange", "keyup", "keydown"], ["class", "text-xs required text-red-400 animate__animated animate__fadeInDown absolute cust-required", 4, "ngIf"], ["class", "text-sm text-blue-400 italic absolute right-0 cust-subline", 4, "ngIf"], [1, "text-xs", "required", "text-red-400", "animate__animated", "animate__fadeInDown", "absolute", "cust-required"], [1, "text-sm", "text-blue-400", "italic", "absolute", "right-0", "cust-subline"], ["class", "cust-div-efc", 3, "ngClass", 4, "ngIf"], ["class", "text-xs required italic text-red-400 animate__animated animate__fadeInDown absolute cust-required", 4, "ngIf"], [1, "cust-div-efc", 3, "ngClass"], ["tippyClassName", "popover-content", "autocomplete", "field_value_none", 1, "cur-field-efc", "bg-white", "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "text-gray-700", "leading-tight", 3, "ngxTippy", "tippyProps", "id", "ngClass", "ngModel", "min", "readOnly", "prefix", "tuiTextfieldLabelOutside", "pseudoHovered", "max", "pseudoFocused", "ngModelChange", "keyup", "keydown", "blur"], [1, "clear-icon", "efc-clear", 3, "click"], ["class", "btn btn-blue mb", 3, "click", 4, "ngIf"], ["class", "btn btn-blue mb", 3, "disabled", "ngClass", "click", 4, "ngIf"], [1, "btn", "btn-blue", "mb", 3, "click"], [1, "btn", "btn-blue", "mb", 3, "disabled", "ngClass", "click"], ["tippyClassName", "popover-content", "autocomplete", "field_value_none", 1, "cur-field", "bg-white", "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "text-gray-700", "leading-tight", 3, "ngxTippy", "tippyProps", "id", "ngClass", "ngModel", "readOnly", "prefix", "tuiTextfieldLabelOutside", "pseudoHovered", "max", "pseudoFocused", "ngModelChange", "keyup", "keydown", "blur"], ["tippyClassName", "popover-content", "type", "text", "autocomplete", "field_value_none", "autocomplete", "off", 1, "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "mb-2", "py-2", "px-3", "text-gray-700", "mb-2", "leading-tight", "cust-number", 3, "ngxTippy", "tippyProps", "id", "disabled", "ngClass", "placeholder", "value", "maxlength", "ngModel", "keyup", "keydown", "ngModelChange"], [1, "text-xs", "required", "italic", "text-red-400", "animate__animated", "animate__fadeInDown", "absolute", "cust-required"], ["class", "z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3", 4, "ngIf"], ["tippyClassName", "popover-content", 1, "form-select", "block", "w-full", "shadow-md", "cust-select", "mb-2", 3, "ngxTippy", "tippyProps", "ngClass", "id", "ngModel", "disabled", "ngModelChange"], ["value", "", "disabled", "", "selected", ""], [3, "value", 4, "ngFor", "ngForOf"], ["class", "text-xs italic required text-red-400 animate__animated animate__fadeInDown absolute cust-required", 4, "ngIf"], [1, "z-10", "h-full", "leading-snug", "font-normal", "absolute", "text-center", "text-blueGray-300", "absolute", "bg-transparent", "rounded", "text-base", "items-center", "justify-center", "w-8", "pl-3", "py-3"], [3, "value"], [1, "text-xs", "italic", "required", "text-red-400", "animate__animated", "animate__fadeInDown", "absolute", "cust-required"], [1, "relative"], ["tippyClassName", "popover-content", "searchKeyword", "value", 1, "mb-2", 3, "ngxTippy", "tippyProps", "id", "ngModel", "data", "ngClass", "placeholder", "itemTemplate", "notFoundTemplate", "disabled", "inputChanged", "inputCleared", "ngModelChange", "selected", "keyup", "keydown"], ["itemTemplate", ""], ["notFoundTemplate", ""], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"], [1, "mt-2"], ["class", "mt-2 inline-flex flex-row", "tippyClassName", "popover-content", 3, "ngxTippy", "tippyProps", 4, "ngIf"], ["tippyClassName", "popover-content", 1, "mt-2", "inline-flex", "flex-row", 3, "ngxTippy", "tippyProps"], [1, "checkbox-items"], [4, "ngFor", "ngForOf"], ["type", "checkbox", 3, "id", "ngClass", "required", "name", "ngModel", "disabled", "ngModelChange", "change"], [1, "block", "text-gray-600", "text-base", "cust-radio-label", 3, "for"], ["class", "mt-2 inline-flex flex-row", 4, "ngIf"], [1, "mt-2", "inline-flex", "flex-row"], ["role", "radiogroup", 1, "cust-sigleTabBtn-outer"], ["class", "inline-flex flex-row", "tippyClassName", "popover-content", 3, "ngxTippy", "tippyProps", 4, "ngIf"], ["tippyClassName", "popover-content", 1, "inline-flex", "flex-row", 3, "ngxTippy", "tippyProps"], ["class", "block text-gray-600 text-base cust-sigleTabBtn-label", 3, "for", 4, "ngFor", "ngForOf"], [1, "block", "text-gray-600", "text-base", "cust-sigleTabBtn-label", 3, "for"], ["type", "button", 1, "form-radio", "cust-sigleTabBtn", 3, "ngClass", "name", "id", "click"], ["role", "radiogroup", 1, "mt-2", "cust-radio-outer"], ["class", "block text-gray-600 text-base cust-radio-label", 3, "for", 4, "ngFor", "ngForOf"], ["type", "radio", 1, "form-radio", "cust-radio", 3, "ngModel", "ngClass", "name", "id", "value", "required", "ngModelChange"], [1, "ml-3", "mr-5"], ["tippyClassName", "popover-content", 1, "cust-multi-select-div", 3, "ngxTippy", "tippyProps"], ["enableCheckAll", "'false'", 3, "placeholder", "settings", "data", "ngModel", "ngModelChange", "onSelect", "onSelectAll", "onDeSelect"], ["optionsTemplate", ""], ["optionSelectedTemplate", ""], [1, "cust-multi-select", 2, "padding", "1px 10px"], [2, "display", "block", "margin-left", "30px", 3, "ngStyle"], [2, "display", "block", "margin-left", "30px"], ["type", "text", "tippyClassName", "popover-content", "readonly", "", "autocomplete", "off", 1, "text-base", "appearance-none", "shadow-md", "border", "border-gray-200", "rounded", "w-full", "py-2", "px-3", "mb-2", "text-gray-700", "leading-tight", "cust-date", 3, "ngxTippy", "tippyProps", "id", "ngClass", "disabled", "placeholder", "value", "ngModel", "click", "keyup.enter", "ngModelChange"], [1, "row"], [1, "-mt-10", "text-3xl", "text-gray-600", "text-center", "font-normal"]], template: function VirtueFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "template", null, 0);
        i0.ɵɵtext(2, "\n    ");
        i0.ɵɵtemplate(3, VirtueFormComponent_div_3_Template, 3, 3, "div", 1);
        i0.ɵɵtext(4, "\n    ");
        i0.ɵɵtemplate(5, VirtueFormComponent_div_5_Template, 3, 3, "div", 1);
        i0.ɵɵtext(6, "\n    ");
        i0.ɵɵtemplate(7, VirtueFormComponent_div_7_Template, 2, 0, "div", 2);
        i0.ɵɵtext(8, "\n");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, VirtueFormComponent_div_9_Template, 4, 2, "div", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.inputWidget.display.tooltip);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.inputWidget.display.tooltip && ctx.inputWidget.display.label);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.inputWidget.display.tooltip && !ctx.inputWidget.display.label);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.itemHidden() && ctx.inputWidget);
    } }, directives: [i4$1.NgIf, i4$1.NgClass, i4$1.NgSwitch, i4$1.NgSwitchCase, i5.TuiInputPhoneComponent, i5.TuiInputPhoneDirective, i6.NgxTippyDirective, i7.NgControlStatus, i7.NgModel, i4.TuiTextfieldLabelOutsideDirective, i7.DefaultValueAccessor, i5.TuiInputNumberComponent, i5.TuiInputNumberDirective, i7.MaxLengthValidator, i7.SelectControlValueAccessor, i7.NgSelectOption, i7.ɵNgSelectMultipleOption, i4$1.NgForOf, i9.AutocompleteComponent, i7.CheckboxRequiredValidator, i7.CheckboxControlValueAccessor, i7.RadioControlValueAccessor, i7.RequiredValidator, i10.MultiSelectComponent, i4$1.NgStyle], pipes: [FormatLabelPipe, FormatSublinePipe], styles: [".disabled-calculate[_ngcontent-%COMP%]{cursor:not-allowed!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VirtueFormComponent, [{
        type: Component,
        args: [{
                selector: 'lib-virtue-form',
                templateUrl: './virtue-form.component.html',
                styleUrls: ['./virtue-form.component.css'],
                providers: [
                    {
                        provide: TUI_NUMBER_FORMAT,
                        useValue: { decimalSeparator: '.', thousandSeparator: ',' },
                    },
                ],
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.NgZone }, { type: i4.TuiDialogService, decorators: [{
                type: Inject,
                args: [TuiDialogService]
            }] }, { type: i0.ChangeDetectorRef }, { type: i0.Injector, decorators: [{
                type: Inject,
                args: [Injector]
            }] }, { type: ConfigMapService }, { type: HttpService }, { type: CodehelpService }]; }, { addInput: [{
            type: Output
        }], removeInput: [{
            type: Output
        }], errorInput: [{
            type: Output
        }], validated: [{
            type: Output
        }], inputWidget: [{
            type: Input,
            args: ['inputWidget']
        }], answerMap: [{
            type: Input,
            args: ['answerMap']
        }], value: [{
            type: Input,
            args: ['value']
        }], altValue: [{
            type: Input,
            args: ['altValue']
        }], widgetno: [{
            type: Input,
            args: ['widgetno']
        }], disabled: [{
            type: Input,
            args: ['disabled']
        }], showError: [{
            type: Input,
            args: ['showError']
        }], configId: [{
            type: Input,
            args: ['configId']
        }], outerClassUsed: [{
            type: Input,
            args: ['outerClassUsed']
        }] }); })();

class VirtueChartComponent {
    constructor() {
        this.data = '';
    }
    ngOnInit() {
    }
}
VirtueChartComponent.ɵfac = function VirtueChartComponent_Factory(t) { return new (t || VirtueChartComponent)(); };
VirtueChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VirtueChartComponent, selectors: [["lib-virtue-chart"]], inputs: { data: "data" }, decls: 3, vars: 0, template: function VirtueChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p");
        i0.ɵɵtext(1, "virtue-chart works!");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(2, "\njkhnkjhn");
    } }, styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VirtueChartComponent, [{
        type: Component,
        args: [{
                selector: 'lib-virtue-chart',
                templateUrl: './virtue-chart.component.html',
                styleUrls: ['./virtue-chart.component.css']
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

class VirtueFormModule {
}
VirtueFormModule.ɵfac = function VirtueFormModule_Factory(t) { return new (t || VirtueFormModule)(); };
VirtueFormModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: VirtueFormModule });
VirtueFormModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        CodehelpService,
        HttpClient,
        DateDialogComponent
    ], imports: [[
            BrowserModule,
            FormsModule,
            ReactiveFormsModule,
            TuiLetModule,
            TuiDialogModule,
            TuiPrimitiveTextfieldModule,
            TuiSvgModule,
            TuiInputModule,
            TuiRootModule,
            NgxTippyModule,
            TuiTextfieldControllerModule,
            TuiMarkerIconModule,
            AutocompleteLibModule,
            TuiInputNumberModule,
            TuiInputPhoneModule,
            TuiCalendarMonthModule,
            TuiDataListModule,
            TuiCalendarModule,
            TuiDataListWrapperModule,
            TuiMultiSelectModule,
            HttpClientModule,
            TuiTooltipModule,
            TuiHintModule,
            TuiLoaderModule,
            NgMultiSelectDropDownModule.forRoot()
            // BrowserAnimationsModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VirtueFormModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TuiLetModule,
                    TuiDialogModule,
                    TuiPrimitiveTextfieldModule,
                    TuiSvgModule,
                    TuiInputModule,
                    TuiRootModule,
                    NgxTippyModule,
                    TuiTextfieldControllerModule,
                    TuiMarkerIconModule,
                    AutocompleteLibModule,
                    TuiInputNumberModule,
                    TuiInputPhoneModule,
                    TuiCalendarMonthModule,
                    TuiDataListModule,
                    TuiCalendarModule,
                    TuiDataListWrapperModule,
                    TuiMultiSelectModule,
                    HttpClientModule,
                    TuiTooltipModule,
                    TuiHintModule,
                    TuiLoaderModule,
                    NgMultiSelectDropDownModule.forRoot()
                    // BrowserAnimationsModule,
                ],
                declarations: [
                    VirtueFormComponent,
                    DateDialogComponent,
                    VirtueChartComponent,
                    FormatSublinePipe,
                    FormatLabelPipe,
                    EfcDialogComponent,
                    SafeUrlPipe,
                    ChooseToCalulateEFCDialogComponent,
                    // CommonFormComponent
                ],
                exports: [
                    VirtueFormComponent,
                    DateDialogComponent,
                    VirtueChartComponent,
                    EfcDialogComponent
                ],
                providers: [
                    CodehelpService,
                    HttpClient,
                    DateDialogComponent
                ],
                entryComponents: [
                    DateDialogComponent,
                    EfcDialogComponent
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VirtueFormModule, { declarations: [VirtueFormComponent,
        DateDialogComponent,
        VirtueChartComponent,
        FormatSublinePipe,
        FormatLabelPipe,
        EfcDialogComponent,
        SafeUrlPipe,
        ChooseToCalulateEFCDialogComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TuiLetModule,
        TuiDialogModule,
        TuiPrimitiveTextfieldModule,
        TuiSvgModule,
        TuiInputModule,
        TuiRootModule,
        NgxTippyModule,
        TuiTextfieldControllerModule,
        TuiMarkerIconModule,
        AutocompleteLibModule,
        TuiInputNumberModule,
        TuiInputPhoneModule,
        TuiCalendarMonthModule,
        TuiDataListModule,
        TuiCalendarModule,
        TuiDataListWrapperModule,
        TuiMultiSelectModule,
        HttpClientModule,
        TuiTooltipModule,
        TuiHintModule,
        TuiLoaderModule, i10.NgMultiSelectDropDownModule], exports: [VirtueFormComponent,
        DateDialogComponent,
        VirtueChartComponent,
        EfcDialogComponent] }); })();

//start table modal
var chartFontStyle;
(function (chartFontStyle) {
    chartFontStyle[chartFontStyle["normal"] = 0] = "normal";
    chartFontStyle[chartFontStyle["italic"] = 1] = "italic";
    chartFontStyle[chartFontStyle["oblique"] = 2] = "oblique";
})(chartFontStyle || (chartFontStyle = {}));
var Trigger;
(function (Trigger) {
    Trigger[Trigger["item"] = 0] = "item";
    Trigger[Trigger["aixs"] = 1] = "aixs";
})(Trigger || (Trigger = {}));
var CustomMethod;
(function (CustomMethod) {
    CustomMethod[CustomMethod["roundOff"] = 0] = "roundOff";
})(CustomMethod || (CustomMethod = {}));
var RepeatAt;
(function (RepeatAt) {
    RepeatAt["EVERY_MINUTE"] = "EVERY_MINUTE";
    RepeatAt["EVERY_HOUR"] = "EVERY_HOUR";
    RepeatAt["EVERY_DAY"] = "EVERY_DAY";
    RepeatAt["EVERY_WEEK"] = "EVERY_WEEK";
    RepeatAt["EVERY_MONTH"] = "EVERY_MONTH";
    RepeatAt["ONE_TIME"] = "ONE_TIME";
})(RepeatAt || (RepeatAt = {}));

/*
 * Public API Surface of virtue-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CONFIG, CodehelpService, ConfigMapService, CustomMethod, DateDialogComponent, EfcDialogComponent, FormatLabelPipe, FormatSublinePipe, HttpService, InputType, RepeatAt, ReqMethod, SafeUrlPipe, Trigger, VirtueChartComponent, VirtueFormComponent, VirtueFormModule, chartFontStyle, envMode };
